<template>

  <div id="windowWrapper">
    <div id="window">

      <div v-bind:key="'gameUpdates'" class="full-game full-screen-cover gradient-background">

        <!--Splash Screens -->
        <div>
          <div class="splash_container">
            <div id="geo_logo"></div>
            <div id="waikato_logo"></div>
            <div id="kotahi_logo"></div>
            <div id="nz_on_air_GDSR_logo"></div>
          </div>
        </div>

        <!--Bug Report Button-->
        <div id="bugreport_pos">
          <div id="bugreport_BTN"> {{ e("btn_bugreport") }}
            <div id="bugreport_icon"></div>
            <a href="https://forms.gle/vzfKPamvrQ9H4zAH6" target="_blank" style="color: #EEEEEE;">
              <span id="link_span"></span>
            </a>
          </div>
        </div>


        <!--Main Menu-->
        <div class="screen_size" v-if="tag('screentype') == 'MainMenu'">
          <div id="menu_title"></div>
          <div id="menu_BTN_div">
            <div id="menu_BTN" @click="doChoice(0)">{{ storyChoices[0] }}<div id="menu_play_icon"></div>
            </div>
            <div id="language_BTN" @click="doChoice(1)">
              <div id="language_icon"></div>
              <div id="menu_language_text">{{ storyChoices[1] }}</div>
            </div>
            <div id="resource_BTN">
              <div id="externallink_icon"></div><a
                href="https://www.waikato.ac.nz/int/research/institutes-centres-entities/institutes/tkri/access-and-benefit-sharing/"
                target="_blank" style="color: #EEEEEE;">{{ e("btn_resourcekete") }}</a>
            </div>
            <div id="legals_BTN_div">
              <div id="privacypolicy_BTN" @click="doChoice(2)">
                <div id="legals_button_text">{{ storyChoices[2] }}</div>
              </div>
              <div id="termsconditions_BTN" @click="doChoice(3)">
                <div id="legals_button_text">{{ storyChoices[3] }}</div>
              </div>
            </div>
          </div>

          <div class="menu_images">
            <div id="menu_rawiri"></div>
            <div id="menu_tribe1"></div>
            <div id="menu_tribe2"></div>
          </div>
          <div id="menu_jasmine"></div>
          <div id="menu_minister"></div>

          <div id="menu_background"></div>
        </div>

        <!--Terms and Privacy-->
        <div class="screen_size" v-if="tag('screentype') == 'Legals'">
          <div id="policy_container">
            <div id="policy_content">
              <div id="policy_title" v-html="tag('title')"></div>
              <div id="policy_text_box">
                <div id="policy_desc" v-html="tag('section0')"></div>
                <div id="policy_subtitle" v-html="tag('section1_header')"></div>
                <div id="policy_desc" v-html="tag('section1_body')"></div>
                <div id="policy_subtitle" v-html="tag('section2_header')"></div>
                <div id="policy_desc" v-html="tag('section2_body')"></div>
                <div id="policy_subtitle" v-html="tag('section3_header')"></div>
                <div id="policy_desc" v-html="tag('section3_body')"></div>
                <div id="policy_subtitle" v-html="tag('section4_header')"></div>
                <div id="policy_desc" v-html="tag('section4_body')"></div>
                <div id="policy_subtitle" v-html="tag('section5_header')"></div>
                <div id="policy_desc" v-html="tag('section5_body')"></div>
                <div id="policy_subtitle" v-html="tag('section5_header')"></div>
                <div id="policy_desc" v-html="tag('section5_body')"></div>
                <div id="policy_subtitle" v-html="tag('section6_header')"></div>
                <div id="policy_desc" v-html="tag('section6_body')"></div>
                <div id="policy_subtitle" v-html="tag('section7_header')"></div>
                <div id="policy_desc" v-html="tag('section7_body')"></div>
                <!--Terms only-->
                <div id="policy_subtitle" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section8_header')"></div>
                <div id="policy_desc" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section8_body')"></div>
                <div id="policy_subtitle" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section9_header')"></div>
                <div id="policy_desc" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section9_body')"></div>
                <div id="policy_subtitle" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section10_header')"></div>
                <div id="policy_desc" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section10_body')"></div>
                <div id="policy_subtitle" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section11_header')"></div>
                <div id="policy_desc" v-if="tag('sectiontype') == 'Terms'" v-html="tag('section11_body')"></div>
              </div>
            </div>
          </div>

          <div id="policy_buttons">
            <div id="policy_okay_cont_pos">
              <div id="cont_BTN_style" @click="doChoice(0)">
                <div id="cont_BTN" v-html="storyChoices[0]"></div>
              </div>
            </div>
            <div id="policy_terms_cont_pos">
              <div id="cont_BTN_style" @click="doChoice(1)">
                <div id="cont_BTN" v-html="storyChoices[1]"></div>
              </div>
            </div>
          </div>

          <div id="default_background"></div>
        </div>

        <!--Select Language-->
        <div class="screen_size" v-if="tag('screentype') == 'SelectLanguage'">
          <div id="menu_title"></div>
          <div id="language_BTN_div">
            <div id="language_option_BTN" v-bind:key="'languageOption' + index" v-for="(label, index) in storyChoices"
              @click="doChoice(index)">
              <div id="language_option_text">{{ label }}</div>
              <div id="UK_icon" v-if="index == 0"></div>
              <div id="french_icon" v-if="index == 1"></div>
              <div id="german_icon" v-if="index == 2"></div>
              <div id="italian_icon" v-if="index == 3"></div>
              <div id="brazil_icon" v-if="index == 4"></div>
              <div id="spanish_icon" v-if="index == 5"></div>
              <div id="maori_icon" v-if="index == 6"></div>
            </div>
          </div>
        </div>

        <!--Intro-->
        <div class="screen_size" v-if="tag('screentype') == 'Intro'">
          <h1 id="intro_title" v-html="tag('title')"></h1>
          <div id="intro_desc_box">
            <h2 id="intro_box_title" v-html="tag('header')"></h2>
            <p id="intro_box_desc" v-html="tag('description')">
            </p>
          </div>
          <div id="intro_cont_pos">
            <div id="cont_BTN_style" @click="doChoice(0)">
              <div id="cont_BTN">{{ storyChoices[0] }}</div>
              <div id="cont_icon"></div>
            </div>
          </div>
          <div id="intro_char_IMG"></div>
          <div id="default_background"></div>
        </div>

        <!--Data and Participation-->
        <div class="screen_size" v-if="tag('screentype') == 'Intro_StudyParticipation'">
          <h1 id="intro_title" v-html="tag('title')"></h1>
          <div id="data_proc_box">
            <div id="data_title" v-html="tag('d1')"></div>
            <div id="data_desc" v-html="tag('description1')"></div>
            <div id="data_BTN" @click="doChoice(0)" v-html="variable('Btn_DataProtectionStatement')"></div>
          </div>
          <div id="study_part_box">
            <div id="study_title" v-html="tag('d2')"></div>
            <div id="study_desc" v-html="tag('description2')"></div>
          </div>
          <div id='study_BTN_box'>
            <div id="no_BTN" @click="doChoice(2)">{{ variable('btn_No') }}<div id="cross_icon"></div>
            </div>
            <div id="yes_BTN" @click="doChoice(1)">{{ variable('btn_Yes') }}<div id="check_icon"></div>
            </div>
          </div>
          <div id="intro_char_IMG"></div>
          <div id="default_background"></div>
          <!--Data protection modal-->
          <div class="modal_background" v-if="tag('modal') == 'dataprotection'">
            <div id="data_modal_box">
              <div id="data_modal_title" v-html="tag('modalheader')"></div>
              <div id="data_modal_desc" v-html="tag('modaldescription')"></div>
              <div id="data_modal_okay_BTN" @click="doChoice(0)" v-html="storyChoices[0]"></div>
              <div id="data_modal_close_BTN" @click="doChoice(0)">
                <div id="cross_icon"></div>
              </div>
            </div>
          </div>
          <!--Study participant deny modal-->
          <div class="modal_background" v-if="tag('modal') == 'participationconfirmation'">
            <div id="study_modal_box">
              <div id="study_modal_title" v-html="tag('modalheader')"></div>
              <div id="study_modal_desc" v-html="tag('modaldescription')"></div>
              <div id="study_modal_BTN_box">
                <div id="study_modal_return_BTN" @click="doChoice(0)">{{ storyChoices[0] }}<div id="arrow_left_icon">
                  </div>
                </div>
                <div id="study_modal_cancel_BTN" @click="doChoice(1)"> {{ storyChoices[1] }}</div>
              </div>
              <div id="data_modal_close_BTN" @click="doChoice(1)">
                <div id="cross_icon"></div>
              </div>
            </div>
          </div>
        </div>

        <!--Name Character-->
        <div class="screen_size" v-if="tag('screentype') == 'Intro_NameInput'">
          <h1 id="intro_title" v-html="tag('title')"></h1>
          <div id="name_char_box">
            <div id="name_title" v-html="tag('header')"></div>
            <input id="name_input_box" v-model="playerName" :placeholder="e('inputboxlabel_enternamehere')">
          </div>
          <template v-if="playerName.length >= 1">
            <div id="name_cont_pos">
              <div id="cont_BTN_style" @click="doChoice(0)">
                <div id="cont_BTN" v-html="storyChoices[0]"></div>
                <div id="cont_icon"></div>
              </div>
            </div>
          </template>
          <div id="intro_char_IMG"></div>
          <div id="default_background"></div>
        </div>

        <!--Choosing a Scenario-->
        <div class="screen_size" v-if="tag('screentype') == 'ScenarioSelect'">
          <div id="scene_title" v-html="tag('title')"></div>
          <div id="scene_desc" v-html="tag('description')"></div>
          <!--Scenario 1-->
          <div id="scene_1_pos">
            <div id="card_hover_wrap">
              <div id="card_box">
                <div id="card_IMG">
                  <div id="fungus_IMG"></div>
                </div>
                <div id="card_title" v-html="tag('header1')"></div>
                <div id="card_desc" v-html="tag('description1')"></div>
                <div id="card_BTN" @click="selectScenario(1)">{{ storyChoices[0] }}<div id="cont_icon"></div>
                </div>
              </div>
            </div>
          </div>
          <!--Scenario 2-->
          <div id="scene_2_pos">
            <div id="card_hover_wrap">
              <div id="card_box">
                <div id="card_IMG">
                  <div id="seaweed_IMG"></div>
                </div>
                <div id="card_title" v-html="tag('header2')"></div>
                <div id="card_desc" v-html="tag('description2')"></div>
                <div id="card_BTN" @click="selectScenario(2)">{{ storyChoices[1] }}<div id="cont_icon"></div>
                </div>
              </div>
            </div>
          </div>
          <!--Scenario 3-->
          <div id="scene_3_pos">
            <div id="card_hover_wrap">
              <div id="card_box">
                <div id="card_IMG">
                  <div id="kawakawa_IMG"></div>
                </div>
                <div id="card_title" v-html="tag('header3')"></div>
                <div id="card_desc" v-html="tag('description3')"></div>
                <div id="card_BTN" @click="selectScenario(3)">{{ storyChoices[2] }}<div id="cont_icon"></div>
                </div>
              </div>
            </div>
          </div>
          <div id="default_background"></div>
        </div>

        <!--Strategic Approach Invalid Choice-->
        <div class="screen_size" v-if="tag('screentype') == 'StrategicApproachInvalidChoice'">

          <!--Speaker and Title-->
          <div id="invalidchoice_speaker_box" v-html="storyText"></div>
          <template v-if="tag('speaker') != 'Exposition'">
            <!--<div id="speaker_name" v-html="friendlyName"></div>
            <div id="speaker_title" v-html="description"></div> -->
          </template>
          <div id="speaker_IMG">
            <div id="tribal_IMG" v-if="tag('speaker') == 'TribalLeaders'"></div>
            <div id="rawiri_IMG" v-if="tag('speaker') == 'Rawiri'"></div>
            <div id="gov_IMG" v-if="tag('speaker') == 'MinisterLong'"></div>
            <div id="invalidchoice_jas_IMG" v-if="tag('speaker') == 'JasmineStrong'"></div>
            <div id="tribaLevel_Initiatives__IMG" v-if="tag('speaker') == 'TribalLeader2'"></div>
          </div>

          <!--Statics-->
          <div id="invalidchoice_cont_pos">
            <div id="cont_BTN_style" v-if="storyChoices.length == 0" @click="doChoice(0)">
              <div id="cont_BTN">{{ e('btn_okay') }}</div>
              <!--<div id="cont_icon"></div>-->
            </div>
          </div>

          <div id="meeting_background" v-if="tag('location') == 'MeetingHouse'"></div>
          <div id="gov_background" v-if="tag('location') == 'GovernmentOffice'"></div>
          <div id="board_background" v-if="tag('location') == 'CorporateBoardroom'"></div>
        </div>

        <!--Dialogue (any of them)-->
        <div class="screen_size" v-if="tag('screentype') == 'Dialogue'">

          <!--Scoring Rings-->
          <div id="dialogue_scores">
            <div id="rela_ring">
              <tippy :content="e('label_relationship')" :arrow="false">
                <radial-progress :diameter="75" :stroke-width="6" :inner-stroke-width="6"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="intVariable('RelationshipScore')"
                  :total-steps="intVariable('RelationshipRingMax')" :start-color="'#B23256'" :stop-color="'#B23256'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="rela_IMG"> </div>
                </radial-progress>
              </tippy>
            </div>
            <div id="fair_ring">
              <tippy :content="e('label_fairness')" :arrow="false">
                <radial-progress :diameter="75" :stroke-width="6" :inner-stroke-width="6"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="intVariable('FairnessScore')"
                  :total-steps="intVariable('FairnessRingMax')" :start-color="'#3F47B2'" :stop-color="'#3247B2'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="fair_IMG"></div>
                </radial-progress>
              </tippy>
            </div>
            <div id="equit_ring">
              <tippy :content="e('label_equity')" :arrow="false">
                <radial-progress :diameter="75" :stroke-width="6" :inner-stroke-width="6"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="intVariable('EquityScore')"
                  :total-steps="intVariable('EquityRingMax')" :start-color="'#32B285'" :stop-color="'#32B285'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="equit_IMG"></div>
                </radial-progress>
              </tippy>
            </div>
          </div>

          <!--Speaker and Title-->
          <div id="speaker_box" v-html="storyText"></div>
          <template v-if="tag('speaker') != 'Exposition'">
            <div id="speaker_name" v-html="friendlyName"></div>
            <div id="speaker_title" v-html="description"></div>
          </template>
          <div id="speaker_IMG">
            <div id="tribal_IMG" v-if="tag('speaker') == 'TribalLeaders'"></div>
            <div id="rawiri_IMG" v-if="tag('speaker') == 'Rawiri'"></div>
            <div id="gov_IMG" v-if="tag('speaker') == 'MinisterLong'"></div>
            <div id="jas_IMG" v-if="tag('speaker') == 'JasmineStrong'"></div>

            <div id="tribaLevel_Initiatives__IMG" v-if="tag('speaker') == 'TribalLeader2'"></div>
          </div>
          <div id="dialogue_title_box" v-html="tag('levelTitle')"></div>

          <!--Choices-->
          <div id="choices_layout">
            <template v-bind:key="'choice' + index" v-for="(choice, index) of storyChoices">
              <div id="encompassing_dialogue_box" @click="doChoice(index)">
                <div id="dialogue_title" v-html="choiceHeader(index)"></div>
                <div id="dialogue_container">
                  <div id="dialogue_box" v-html="choiceDescription(index)"></div>
                  <div id="context_icon" v-if="tag('context') == (index + 1 + '')"></div>
                </div>
              </div>
            </template>
          </div>

          <!--Statics-->
          <div id="dialogue_cont_pos">
            <div id="cont_BTN_style" v-if="storyChoices.length == 0" @click="doContinue()">
              <div id="cont_BTN">{{ e('btn_continue') }}</div>
              <div id="cont_icon"></div>
            </div>
          </div>

          <div id="meeting_background" v-if="tag('location') == 'MeetingHouse'"></div>
          <div id="gov_background" v-if="tag('location') == 'GovernmentOffice'"></div>
          <div id="board_background" v-if="tag('location') == 'CorporateBoardroom'"></div>
        </div>

        <!--Budget Slider-->
        <div class="screen_size" v-if="tag('screentype') == 'BudgetSlider'">
          <div id="budget_title" v-html="tag('title')"></div>
          <div id="budget_desc" v-html="tag('header')"></div>

          <div id="dialogue_cont_pos">
            <div id="cont_BTN_style" @click="doChoice(0)">
              <div id="cont_BTN">{{ e('btn_confirm') }}</div>
              <div id="check_icon"></div>
            </div>
          </div>

          <div id="default_background"></div>

          <!--read https://nightcatsama.github.io/vue-slider-component/#/ for documentation -->
          <div class="budget-slider-container">
            <div class="budget-slider-amount">
              ${{ formatNumber(getNumberVariable('ScenarioBudgetAssigned')) }}
            </div>
            <div id="slider_title">{{ e('budget_selection') }}</div>
            <div id="slider_max">{{ e('budget_total_percentage') }} {{ (scenarioBudgetAssigned * 100) /
              intVariable('ScenarioBudget')
            }}%</div>

            <!-- formatNumber(placeVariable('ScenarioPercentage')) -->

            <!-- Interval set to 5000 so it doesn't throw an error when the max budget is 125000 -->
            <!-- Needs to be cleanly divisible so ScenarioBudget/Interval is a whole number -->
            <vue-slider :max="intVariable('ScenarioBudget')" :interval="5000" :zoom="zoom" class="budget-slider"
              width="612px" height="32px" v-model="scenarioBudgetAssigned"></vue-slider>

          </div>
          <!--Not Enough Budget Modal-->
          <div class="modal_background" v-if="tag('modal') == 'notenoughbudget'">
            <div id="no_budget_modal_box">
              <div id="no_budget_title">{{ tag('modalheader') }}</div>
              <div id="no_budget_desc">{{ tag('modaldescription') }}</div>
              <div id="budget_okay_BTN" @click="doChoice(0)" v-html="storyChoices[0]"></div>
              <!--<div id="data_modal_close_BTN" @click="doChoice(0)">
                <div id="cross_icon"></div>
              </div>-->
            </div>
          </div>
        </div>

        <!--Budget Allocation Add and Subtract**-->
        <div class="screen_size" v-if="tag('screentype') == 'BudgetAllocation'">
          <div id="allocation_title" v-html="tag('title')"></div>
          <div id="allocation_description" v-html="tag('description')"></div>

          <div id="alloc_background_lines_box">
            <div id="alloc_top_line"></div>
            <div id="alloc_middle_line"></div>
            <div id="alloc_bottom_line"></div>
            <div id="alloc_vertical_line"></div>
          </div>

          <div id="allocation_grid_box">
            <!--Row Titles and Descriptors (Column 1)-->
            <div class="alloc_type_box row-1 column-1">
              <div id="type_title">
                <div id="schol_icon"></div>{{ tag('header1') }}
              </div>
              <div id="type_desc" v-html="tag('description1')"></div>
            </div>

            <div class="alloc_type_box row-2 column-1">
              <div id="type_title">
                <div id="comm_icon"></div>{{ tag('header2') }}
              </div>
              <div id="type_desc" v-html="tag('description2')"></div>
            </div>

            <div class="alloc_type_box row-3 column-1">
              <div id="type_title">
                <div id="indi_icon"></div>{{ tag('header3') }}
              </div>
              <div id="type_desc" v-html="tag('description3')"></div>
            </div>

            <!--Scholarly Tiers-->
            <div class="alloc_adds_box row-1 column-2">
              <div id="adds_title" v-html="tag('budget1')"></div>
              <div id="adds_cost">$5k</div>
              <div id="adds_amount" v-if="intVariable('student')" v-html="intVariable('Student') / 5000"></div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('student') >= 1" @click="doChoice(1)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('student') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 5000" @click="doChoice(0)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 5000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-1 column-3">
              <div id="adds_title" v-html="tag('budget2')"></div>
              <div id="adds_cost">$10k</div>
              <div id="adds_amount" v-if="intVariable('intern')" v-html="intVariable('Intern') / 10000"></div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('intern') >= 1" @click="doChoice(3)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('intern') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 10000" @click="doChoice(2)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 10000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-1 column-4">
              <div id="adds_title" v-html="tag('budget3')"></div>
              <div id="adds_cost">$20k</div>
              <div id="adds_amount" v-if="intVariable('Masters')" v-html="intVariable('Masters') / 20000"></div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('Masters') >= 1" @click="doChoice(5)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('Masters') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 20000" @click="doChoice(4)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 20000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-1 column-5">
              <div id="adds_title" v-html="tag('budget4')"></div>
              <div id="adds_cost">$40k</div>
              <div id="adds_amount" v-if="intVariable('PhD')" v-html="intVariable('PhD') / 40000"></div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('PhD') >= 1" @click="doChoice(7)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('PhD') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 40000" @click="doChoice(6)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 40000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <!--Community Tiers-->
            <div class="alloc_adds_box row-2 column-2">
              <div id="adds_title" v-html="tag('budget5')"></div>
              <div id="adds_cost">$2.5k</div>
              <div id="adds_amount" v-if="intVariable('CommunityMeeting')"
                v-html="intVariable('CommunityMeeting') / 2500">
              </div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('CommunityMeeting') >= 1" @click="doChoice(9)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('CommunityMeeting') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 2500" @click="doChoice(8)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 2500">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-2 column-3">
              <div id="adds_title" v-html="tag('budget6')"></div>
              <div id="adds_cost">$5k</div>
              <div id="adds_amount" v-if="intVariable('SmallWorkshop')" v-html="intVariable('SmallWorkshop') / 5000">
              </div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('smallworkshop') >= 1" @click="doChoice(11)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('smallworkshop') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 5000" @click="doChoice(10)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 5000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-2 column-4">
              <div id="adds_title" v-html="tag('budget7')"></div>
              <div id="adds_cost">$10k</div>
              <div id="adds_amount" v-if="intVariable('CommunityEvent')" v-html="intVariable('CommunityEvent') / 10000">
              </div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('communityevent') >= 1" @click="doChoice(13)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('communityevent') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 10000" @click="doChoice(12)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 10000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-2 column-5">
              <div id="adds_title" v-html="tag('budget8')"></div>
              <div id="adds_cost">$20k</div>
              <div id="adds_amount" v-if="intVariable('CapacityBuildingProgram')"
                v-html="intVariable('CapacityBuildingProgram') / 20000"></div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('CapacityBuildingProgram') >= 1" @click="doChoice(15)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('CapacityBuildingProgram') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 20000" @click="doChoice(14)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 20000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <!--Researcher Tiers-->
            <div class="alloc_adds_box row-3 column-2">
              <div id="adds_title" v-html="tag('budget9')"></div>
              <div id="adds_cost">$10k</div>
              <div id="adds_amount" v-if="intVariable('CommunityAdvisoryGroup')"
                v-html="intVariable('CommunityAdvisoryGroup') / 10000"></div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('CommunityAdvisoryGroup') >= 1" @click="doChoice(17)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('CommunityAdvisoryGroup') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 10000" @click="doChoice(16)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 10000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-3 column-3">
              <div id="adds_title" v-html="tag('budget10')"></div>
              <div id="adds_cost">$20k</div>
              <div id="adds_amount" v-if="intVariable('Consultant')" v-html="intVariable('Consultant') / 20000"></div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('consultant') >= 1" @click="doChoice(19)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('consultant') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 20000" @click="doChoice(18)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 20000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-3 column-4">
              <div id="adds_title" v-html="tag('budget11')"></div>
              <div id="adds_cost">$40k</div>
              <div id="adds_amount" v-if="intVariable('PartTimeResearcher')"
                v-html="intVariable('PartTimeResearcher') / 40000">
              </div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('PartTimeResearcher') >= 1" @click="doChoice(21)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('PartTimeResearcher') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 40000" @click="doChoice(20)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 40000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <div class="alloc_adds_box row-3 column-5">
              <div id="adds_title" v-html="tag('budget12')"></div>
              <div id="adds_cost">$80k</div>
              <div id="adds_amount" v-if="intVariable('FullTimeResearcher')"
                v-html="intVariable('FullTimeResearcher') / 80000">
              </div>
              <div id="adds_BTN_box">
                <div id="adds_sub_BTN" v-if="intVariable('FullTimeResearcher') >= 1" @click="doChoice(23)">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_sub_BTN_nil"
                  v-if="intVariable('scenariobudget') == intVariable('totalBudget') || intVariable('FullTimeResearcher') < 1">
                  <div id="sub_icon"></div>
                </div>
                <div id="adds_add_BTN" v-if="intVariable('scenariobudget') >= 80000" @click="doChoice(22)">
                  <div id="add_icon"></div>
                </div>
                <div id="adds_add_BTN_nil" v-if="intVariable('scenariobudget') < 80000">
                  <div id="add_icon"></div>
                </div>
              </div>
            </div>

            <!--Remaining Budget Section-->
            <div id="alloc_remaining">
              <div id="remain_box">
                <div id="remain_title" v-html="tag('header')"></div>
                <div id="remain_spent">${{ formatNumber(intVariable('scenariobudget')) }}</div>
                <div id="remain_outOf">/${{ formatNumber(intVariable('totalBudget')) }}</div>
              </div>
            </div>
          </div>

          <div id="dialogue_cont_pos">
            <div id="cont_BTN_style" @click="doChoice(24)">
              <div id="cont_BTN">{{ e('btn_continue') }}</div>
              <div id="cont_icon"></div>
            </div>
          </div>

          <!--Confirm Budget Modal-->
          <div class="modal_background" v-if="tag('modal') == 'confirmfunding'">
            <div id="study_modal_box">
              <div id="confirm_modal_title">{{ tag('modalheader') }}</div>
              <div id="study_modal_desc">{{ tag('modaldescription') }}</div>
              <div id="study_modal_BTN_box">
                <div id="study_modal_return_BTN" @click="doChoice(1)">{{ storyChoices[1] }}<div id="check_icon"></div>
                </div>
                <div id="study_modal_cancel_BTN" @click="doChoice(0)">{{ storyChoices[0] }}<div id="cross_icon"></div>
                </div>
              </div>
              <div id="data_modal_close_BTN" @click="doChoice(0)">
                <div id="cross_icon"></div>
              </div>
            </div>
          </div>

          <div id="default_background"></div>
        </div>

        <!--Best-worst Survey Definitions-->
        <div class="screen_size" v-if="tag('screentype') == 'SurveyDefinitions'">
          <div id="survey_title" v-html="tag('title')"></div>
          <div id="survey_intro_desc" v-html="storyText"></div>
          <!--<div id="speaker_name" v-html="friendlyName"></div>
          <div id="speaker_title" v-html="description"></div>-->
          <!--<div id="speaker_placement_alt">
            <div id="jas_IMG"></div>
          </div>-->

          <div id="survey_def_box">
            <div id="survey_def_row">
              <div id="survey_def_header" v-html="tag('title0')"></div>
              <div id="survey_def_header2" v-html="tag('desc0')"></div>
            </div>
            <div id="survey_def_row">
              <div id="survey_def_title" v-html="tag('title1')"></div>
              <div id="survey_def_desc" v-html="tag('desc1')"></div>
            </div>
            <div id="survey_def_row">
              <div id="survey_def_title" v-html="tag('title2')"></div>
              <div id="survey_def_desc" v-html="tag('desc2')"></div>
            </div>
            <div id="survey_def_row">
              <div id="survey_def_title" v-html="tag('title3')"></div>
              <div id="survey_def_desc" v-html="tag('desc3')"></div>
            </div>
            <div id="survey_def_row">
              <div id="survey_def_title" v-html="tag('title4')"></div>
              <div id="survey_def_desc" v-html="tag('desc4')"></div>
            </div>
            <div id="survey_def_row">
              <div id="survey_def_title" v-html="tag('title5')"></div>
              <div id="survey_def_desc" v-html="tag('desc5')"></div>
            </div>
            <div id="survey_def_row">
              <div id="survey_def_title" v-html="tag('title6')"></div>
              <div id="survey_def_desc" v-html="tag('desc6')"></div>
            </div>
            <div id="survey_def_row">
              <div id="survey_def_title" v-html="tag('title7')"></div>
              <div id="survey_def_desc" v-html="tag('desc7')"></div>
            </div>
          </div>

          <div id="keyconsiderations_cont_pos">
            <div id="cont_BTN_style" v-if="storyChoices.length == 0" @click="doContinue()">
              <div id="cont_BTN">{{ e('btn_continue') }}</div>
              <div id="cont_icon"></div>
            </div>
          </div>
          <div id="default_background"></div>

        </div>

        <!--Best-worst Survey Choices-->
        <div class="screen_size" v-if="tag('screentype') == 'SurveyChoices'">
          <div id="survey_title" v-html="tag('title')"></div>
          <!--<div id="speaker_name" v-html="friendlyName"></div>
          <div id="speaker_title" v-html="description"></div>-->
          <div id="speaker_placement">
            <div id="jas_IMG"></div>
          </div>

          <div id="survey_choices_group" v-bind:key="'SurveyContainer' + surveyNextClicked"
            :class="{ 'animated': surveyNextClicked }">
            <div id="least_title" v-html="tag('least')"></div>
            <div id="most_title" v-html="tag('most')"></div>
            <div id="question_title" v-html="tag('quest')"></div>
            <div id="survey_container">
              <div id="survey_choice_box">
                <input id="radio_left" type="radio" name="leastchoice" :value="variable('Option1')" v-model="leastValue"
                  @click="doChoice(0)">
                <tippy :content="variable('Description1')" :arrow="false" :maxWidth="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_choice_title">{{ variable('Option1') }}
                </tippy>
                <input id="radio_right" type="radio" name="mostchoice" :value="variable('Option1')" v-model="mostValue"
                  @click="doChoice(3)">
              </div>
              <div id="survey_choice_box">
                <input id="radio_left" type="radio" name="leastchoice" :value="variable('Option2')" v-model="leastValue"
                  @click="doChoice(1)">
                <tippy :content="variable('Description2')" :arrow="false" :maxWidth="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_choice_title">{{ variable('Option2') }}
                </tippy>
                <input id="radio_right" type="radio" name="mostchoice" :value="variable('Option2')" v-model="mostValue"
                  @click="doChoice(4)">
              </div>
              <div id="survey_choice_box">
                <input id="radio_left" type="radio" name="leastchoice" :value="variable('Option3')" v-model="leastValue"
                  @click="doChoice(2)">
                <tippy :content="variable('Description3')" :arrow="false" :maxWidth="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_choice_title">{{ variable('Option3') }}
                </tippy>
                <input id="radio_right" type="radio" name="mostchoice" :value="variable('Option3')" v-model="mostValue"
                  @click="doChoice(5)">
              </div>
            </div>
            <div id="survey_next_pos">
              <div id="next_BTN_style" @click="surveyNext" v-if="radioNextDisabled == false">
                <div id="next_BTN">{{ e('btn_next') }}</div>
                <div id="arrow_down_icon"></div>
              </div>
              <div id="next_BTN_style_disabled" v-if="radioNextDisabled == true">
                <div id="next_BTN">{{ e('btn_next') }}</div>
                <div id="arrow_down_icon"></div>
              </div>
            </div>
          </div>

          <!-- DEBUGGING RANKS
          <div class="priorityRankingContainer">
            <div v-for="(p, index) in getAllScores()" v-bind:key="'priorityRanking' + index">
              Priority: {{ p.priority }} Score: {{ p.score }}
            </div>
          </div>-->
          <div id="board_background"></div>
        </div>

        <!--Stage Complete-->
        <div class="screen-size" v-if="tag('screentype') == 'StageComplete'">
          <div id="stage_title" v-html="tag('title')"></div>

          <div id="stage_text_box" v-if="tag('completiontype') != 'Stage3' && tag('completiontype') != 'SLOTeval'">
            <div id="stage_result_title" v-if="tag('completiontype') != 'Stage3'" v-html="tag('header')"></div>
            <div id="stage_rela_container" v-if="tag('completiontype') != 'Stage3'">
              <div id="stage_rela_ring">
                <radial-progress :diameter="110" :stroke-width="9" :inner-stroke-width="9"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('RelationshipScore')"
                  :total-steps="intVariable('RelationshipRingMax')" :start-color="'#b23256'" :stop-color="'#b23256'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="stage_rela_IMG"></div>
                </radial-progress>
              </div>
              <div id="stage_rela_desc" v-html="tag('desc1')"></div>
            </div>
            <div id="stage_fair_container" v-if="tag('completiontype') != 'Stage3'">
              <div id="stage_fair_ring">
                <radial-progress :diameter="110" :stroke-width="9" :inner-stroke-width="9"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('FairnessScore')"
                  :total-steps="intVariable('FairnessRingMax')" :start-color="'#3247b2'" :stop-color="'#3247b2'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="stage_fair_IMG"></div>
                </radial-progress>
              </div>
              <div id="stage_fair_desc" v-html="tag('desc2')"></div>
            </div>
            <div id="stage_equit_container" v-if="tag('completiontype') != 'Stage3'">
              <div id="stage_equit_ring">
                <radial-progress :diameter="110" :stroke-width="9" :inner-stroke-width="9"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('EquityScore')"
                  :total-steps="intVariable('EquityRingMax')" :start-color="'#32b285'" :stop-color="'#32b285'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="stage_equit_IMG"></div>
                </radial-progress>
              </div>
              <div id="stage_equit_desc" v-html="tag('desc3')"></div>
            </div>
          </div>

          <!--Best-Worst Survey Only-->
          <div id="survey_result_desc" v-html="tag('description')" v-if="tag('completiontype') == 'Stage3'"></div>
          <div id="survey_rank_box" v-if="tag('completiontype') == 'Stage3'">
            <div id="survey_rank_container">
              <div id="survey_rank_row">
                <div id="survey_rank_number">1</div>
                <!--<div id="survey_rank_desc">{{ getAllScores()[0].priority }}</div>-->
                <tippy :content="getAllScores()[0].definition" :arrow="false" :max-width="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_rank_desc">
                  {{ getAllScores()[0].priority }}
                </tippy>
              </div>
              <div id="survey_rank_row">
                <div id="survey_rank_number">2</div>
                <!--<div id="survey_rank_desc">{{ getAllScores()[1].priority }}</div>-->
                <tippy :content="getAllScores()[1].definition" :arrow="false" :max-width="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_rank_desc">
                  {{ getAllScores()[1].priority }}
                </tippy>
              </div>
              <div id="survey_rank_row">
                <div id="survey_rank_number">3</div>
                <!--<div id="survey_rank_desc">{{ getAllScores()[2].priority }}</div>-->
                <tippy :content="getAllScores()[2].definition" :arrow="false" :max-width="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_rank_desc">
                  {{ getAllScores()[2].priority }}
                </tippy>
              </div>
              <div id="survey_rank_row">
                <div id="survey_rank_number">4</div>
                <!--<div id="survey_rank_desc">{{ getAllScores()[3].priority }}</div>-->
                <tippy :content="getAllScores()[3].definition" :arrow="false" :max-width="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_rank_desc">
                  {{ getAllScores()[3].priority }}
                </tippy>
              </div>
              <div id="survey_rank_row">
                <div id="survey_rank_number">5</div>
                <!--<div id="survey_rank_desc">{{ getAllScores()[4].priority }}</div>-->
                <tippy :content="getAllScores()[4].definition" :arrow="false" :max-width="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_rank_desc">
                  {{ getAllScores()[4].priority }}
                </tippy>
              </div>
              <div id="survey_rank_row">
                <div id="survey_rank_number">6</div>
                <!--<div id="survey_rank_desc">{{ getAllScores()[5].priority }}</div>-->
                <tippy :content="getAllScores()[5].definition" :arrow="false" :max-width="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_rank_desc">
                  {{ getAllScores()[5].priority }}
                </tippy>
              </div>
              <div id="survey_rank_row">
                <div id="survey_rank_number">7</div>
                <!--<div id="survey_rank_desc">{{ getAllScores()[6].priority }}</div>-->
                <tippy :content="getAllScores()[6].definition" :arrow="false" :max-width="384" :placement="'top'"
                  :offset="[0, 12]" :follow-cursor="'horizontal'" id="survey_rank_desc">
                  {{ getAllScores()[6].priority }}
                </tippy>
              </div>
            </div>
            <div id="rank_most_title" v-html="tag('header1')"></div>
          </div>
          <div id="stage_text_box2" v-if="tag('completiontype') == 'Stage3'">
            <div id="stage_result_title" v-if="tag('completiontype') == 'Stage3'" v-html="tag('header')"></div>
            <div id="stage_rela_container" v-if="tag('completiontype') == 'Stage3'">
              <div id="stage_rela_ring">
                <radial-progress :diameter="110" :stroke-width="9" :inner-stroke-width="9"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('RelationshipScore')"
                  :total-steps="intVariable('RelationshipRingMax')" :start-color="'#b23256'" :stop-color="'#b23256'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="stage_rela_IMG"></div>
                </radial-progress>
              </div>
              <div id="stage_rela_desc" v-html="tag('desc1')"></div>
            </div>
            <div id="stage_fair_container" v-if="tag('completiontype') == 'Stage3'">
              <div id="stage_fair_ring">
                <radial-progress :diameter="110" :stroke-width="9" :inner-stroke-width="9"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('FairnessScore')"
                  :total-steps="intVariable('FairnessRingMax')" :start-color="'#3247b2'" :stop-color="'#3247b2'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="stage_fair_IMG"></div>
                </radial-progress>
              </div>
              <div id="stage_fair_desc" v-html="tag('desc2')"></div>
            </div>
            <div id="stage_equit_container" v-if="tag('completiontype') == 'Stage3'">
              <div id="stage_equit_ring">
                <radial-progress :diameter="110" :stroke-width="9" :inner-stroke-width="9"
                  :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('EquityScore')"
                  :total-steps="intVariable('EquityRingMax')" :start-color="'#32b285'" :stop-color="'#32b285'"
                  :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                  <div id="stage_equit_IMG"></div>
                </radial-progress>
              </div>
              <div id="stage_equit_desc" v-html="tag('desc3')"></div>
            </div>
          </div>

          <!--Cultural License to Operate Threshold Evaluation-->
          <div v-if="tag('completiontype') == 'SLOTeval'">
            <div id="stage_text_layout">
              <div id="stage_text_title" v-html="tag('header')"></div>
              <div id="stage_text_desc" v-html="tag('description')"></div>
            </div>
            <!--<div id="stage_cont_pos">
              <div id="cont_BTN_style" @click="doChoice(0)">
                <div id="cont_BTN" v-html="storyChoices[0]"></div>
                <div id="check_icon"></div>
              </div>
            </div>-->
            <div id="reward_IMG">
              <div id="stage_silver" v-if="tag('tiki') == 'Silver'"></div>
              <div id="stage_gold" v-if="tag('tiki') == 'Gold'"></div>
              <div id="stage_bronze" v-if="tag('tiki') == 'Bronze'"></div>
              <div v-else></div>
            </div>

            <div id="gamecomplete_survey_pos">
              <div id="completion_questions_BTN"> {{ e("btn_backgroundquestions") }}
                <div id="externallink_dark_icon"></div>
                <a :href="surveyURL()" target="_blank" style="color: #111111;">
                  <span id="link_span"></span>
                </a>
              </div>
            </div>

          </div>

          <div v-if="tag('completiontype') == 'Stage4'">
            <!--<div id="stage_text_layout">
              <div id="stage_text_title" v-html="tag('header')"></div>
              <div id="stage_text_desc" v-html="tag('description')"></div>
            </div>-->
            <!--<div id="stage_cont_pos">
              <div id="cont_BTN_style" @click="doChoice(0)">
                <div id="cont_BTN" v-html="storyChoices[0]"></div>
                <div id="check_icon"></div>
              </div>
            </div>-->
            <!--<div id="reward_IMG">
              <div id="stage_silver" v-if="tag('tiki') == 'Silver'"></div>
              <div id="stage_gold" v-if="tag('tiki') == 'Gold'"></div>
              <div id="stage_bronze" v-if="tag('tiki') == 'Bronze'"></div>
              <div v-else></div>
            </div>-->
          </div>

          <!-- DEBUGGING RANKS
          <div class="priorityRankingContainer">
            <div v-for="(p, index) in getAllScores()" v-bind:key="'priorityRanking' + index">
              Priority: {{ p.priority }} Score: {{ p.score }}
            </div>
          </div>-->

          <div id="default_background"></div>
          <div id="stage_cont_pos">
            <div id="cont_BTN_style" @click="doChoice(0)">
              <div id="cont_BTN" v-html="storyChoices[0]"></div>
              <div id="check_icon"></div>
            </div>
          </div>
        </div>

        <!--Game Complete-->
        <div class="screen_size" v-if="tag('screentype') == 'Complete'">
          <!--Overall Summary-->
          <div id="comp_overall">
            <div id="overall_title" v-html="tag('title')"></div>
            <div id="overall_desc" v-html="tag('description')"></div>
            <div id="completion_questions_BTN"> {{ e("btn_backgroundquestions") }}
              <div id="externallink_dark_icon"></div>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSffd244hVCnnjxy02UlMNKZbnCBSzp4bz3pT2MMZJ-uU3CbbQ/viewform?usp=pp_url&entry.852708749=111222333"
                target="_blank" style="color: #111111;">
                <span id="link_span"></span>
              </a>
            </div>
            <div id="overall_tiki_title" v-html="tag('header1')"></div>
            <div id="overall_tiki_container">
              <div id="overall_gold_IMG" v-if="variable('PlayerAward') == 'Gold'"></div>
              <div id="overall_silver_IMG" v-if="variable('PlayerAward') == 'Silver'"></div>
              <div id="overall_bronze_IMG" v-if="variable('PlayerAward') == 'Bronze'"></div>
              <div id="overall_tiki_desc" v-html="e('player_award_name')"></div>
            </div>
            <div id="overall_score_title" v-html="tag('header2')"></div>
            <div id="overall_rings_box">
              <!--Relationship Ring-->
              <div id="overall_rings_frame">
                <div id="overall_ring">
                  <radial-progress :diameter="80" :stroke-width="8" :inner-stroke-width="8"
                    :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('TotalRelationshipScore')"
                    :total-steps="placeVariable('TotalRelationshipMax')" :start-color="'#b23256'"
                    :stop-color="'#b23256'" :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                    <div id="overall_rela_IMG"></div>
                  </radial-progress>
                </div>
                <div id="overall_rings_title">{{ formatNumber(placeVariable('TotalRelationshipScore')) }}/{{
                  formatNumber(placeVariable('TotalRelationshipMax')) }}</div>
              </div>
              <!--Fairness Ring-->
              <div id="overall_rings_frame">
                <div id="overall_ring">
                  <radial-progress :diameter="80" :stroke-width="8" :inner-stroke-width="8"
                    :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('TotalFairnessScore')"
                    :total-steps="placeVariable('TotalFairnessMax')" :start-color="'#3247b2'" :stop-color="'#3247b2'"
                    :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                    <div id="overall_fair_IMG"></div>
                  </radial-progress>
                </div>
                <div id="overall_rings_title">{{ formatNumber(placeVariable('TotalFairnessScore')) }}/{{
                  formatNumber(placeVariable('TotalFairnessMax')) }}</div>
              </div>
              <!--Equity Ring-->
              <div id="overall_rings_frame">
                <div id="overall_ring">
                  <radial-progress :diameter="80" :stroke-width="8" :inner-stroke-width="8"
                    :inner-stroke-color="'#FFFFFF'" :completed-steps="placeVariable('TotalEquityScore')"
                    :total-steps="placeVariable('TotalEquityMax')" :start-color="'#32b285'" :stop-color="'#32b285'"
                    :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                    <div id="overall_equit_IMG"></div>
                  </radial-progress>
                </div>
                <div id="overall_rings_title">{{ formatNumber(placeVariable('TotalEquityScore')) }}/{{
                  formatNumber(placeVariable('TotalEquityMax')) }}</div>
              </div>
            </div>
            <!--Buttons-->
            <div id="completion_BTN_box">
              <div id="completion_replay_BTN" @click="doChoice(1)">{{ storyChoices[1] }}<div id="replay_icon"></div>
              </div>
              <div id="completion_return_BTN" @click="doChoice(0)">{{ storyChoices[0] }}</div>
            </div>
            <div id="completion_resource_BTN">
              <div id="externallink_icon"></div><a
                href="https://www.waikato.ac.nz/int/research/institutes-centres-entities/institutes/tkri/access-and-benefit-sharing/"
                target="_blank" style="color: #EEEEEE;">{{ e("btn_resourcekete") }}</a>
            </div>
          </div>
          <!--Individual Levels Summaries-->
          <div id="comp_levels_scroll">
            <!--Level 1-->
            <div id="comp_level_container">
              <div id="comp_level_title" v-html="tag('header3')"></div>
              <div id="comp_Level_Access__scores">
                <!--Relationship Scores-->
                <div id="comp_scores_row">
                  <div id="comp_ring">
                    <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                      :inner-stroke-color="'#ffffff'" :completed-steps="placeVariable('Level_Access_RelationshipScore')"
                      :total-steps="placeVariable('Level_Access_RMax')" :start-color="'#b23256'" :stop-color="'#b23256'"
                      :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                      <div id="comp_rela_IMG"></div>
                    </radial-progress>
                  </div>
                  <div id="comp_desc_rows">
                    <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_Access_RelationshipScore')) }}/{{
                      formatNumber(placeVariable('Level_Access_RMax'))
                    }}</div>
                    <div id="comp_scores_desc" v-html="tag('desc1')"></div>
                  </div>
                </div>
                <!--Fairness Scores-->
                <div id="comp_scores_row">
                  <div id="comp_ring">
                    <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                      :inner-stroke-color="'#ffffff'" :completed-steps="placeVariable('Level_Access_FairnessScore')"
                      :total-steps="placeVariable('Level_Access_FMax')" :start-color="'#3247b2'" :stop-color="'#3247b2'"
                      :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                      <div id="comp_fair_IMG"></div>
                    </radial-progress>
                  </div>
                  <div id="comp_desc_rows">
                    <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_Access_FairnessScore')) }}/{{
                      formatNumber(placeVariable('Level_Access_FMax'))
                    }}</div>
                    <div id="comp_scores_desc" v-html="tag('desc2')"></div>
                  </div>
                </div>
                <!--Equity Scores-->
                <div id="comp_scores_row">
                  <div id="comp_ring">
                    <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                      :inner-stroke-color="'#ffffff'" :completed-steps="placeVariable('Level_Access_EquityScore')"
                      :total-steps="placeVariable('Level_Access_EMax')" :start-color="'#32b285'" :stop-color="'#32b285'"
                      :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                      <div id="comp_equit_IMG"></div>
                    </radial-progress>
                  </div>
                  <div id="comp_desc_rows">
                    <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_Access_EquityScore')) }}/{{
                      formatNumber(placeVariable('Level_Access_EMax'))
                    }}</div>
                    <div id="comp_scores_desc" v-html="tag('desc3')"></div>
                  </div>
                </div>
              </div>
            </div>
            <!--Level 2-->
            <div id="comp_level_container">
              <div id="comp_level_title" v-html="tag('header4')"></div>
              <div id="comp_Level_Initiatives__column">
                <div id="comp_Level_Initiatives__row">
                  <div id="comp_Level_Initiatives__title" v-html="tag('Level_Initiatives_title1')"></div>
                  <div id="comp_Level_Initiatives__desc">${{ formatNumber(intVariable('ScenarioBudgetAssigned')) }} - {{
                    formatNumber(intVariable('ScenarioPercentage')) }}%</div>
                  <div id="comp_Level_Initiatives__title" v-html="tag('Level_Initiatives_title2')"></div>
                  <div id="comp_ini_gapless">
                    <!--Scholarly tiers-->
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget1') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountStudent')) }}</div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('Student')) }}</div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget2') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountIntern')) }}</div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('Intern')) }}</div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget3') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountMasters')) }}</div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('Masters')) }}</div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget4') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountPhD')) }}</div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('PhD')) }}</div>
                    </div>
                    <!--Community tiers-->
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget5') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountCommunityMeeting')) }}
                      </div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('CommunityMeeting')) }}</div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget6') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountSmallWorkshop')) }}</div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('SmallWorkshop')) }}</div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget7') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountCommunityEvent')) }}
                      </div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('CommunityEvent')) }}</div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget8') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{
                        formatNumber(intVariable('CountCapacityBuildingProgram')) }}
                      </div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('CapacityBuildingProgram')) }}
                      </div>
                    </div>
                    <!--Research tiers-->
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget9') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountCommunityAdvisoryGroup'))
                      }}
                      </div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('CommunityAdvisoryGroup')) }}
                      </div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget10') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountConsultant')) }}</div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('Consultant')) }}</div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget11') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountPartTimeResearcher')) }}
                      </div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('PartTimeResearcher')) }}
                      </div>
                    </div>
                    <div id="comp_ini_row">
                      <div id="comp_Level_Initiatives__desc2">{{ e('scrn_budgetallocation_budget12') }}</div>
                      <div id="comp_Level_Initiatives__desc">{{ formatNumber(intVariable('CountFullTimeResearcher')) }}
                      </div>
                      <div id="comp_Level_Initiatives__desc3">{{ formatNumber(intVariable('FullTimeResearcher')) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div id="comp_Level_Initiatives__row">
                  <!--Relationship Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_Initiatives_RelationshipScore')"
                        :total-steps="placeVariable('Level_Initiatives_RMax')" :start-color="'#b23256'"
                        :stop-color="'#b23256'" :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_rela_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_rows">
                      <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_Initiatives_RelationshipScore'))
                      }}/{{
                          formatNumber(placeVariable('Level_Initiatives_RMax')) }}</div>
                      <div id="comp_scores_desc" v-html="tag('desc4')"></div>
                    </div>
                  </div>
                  <!--Fairness Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_Initiatives_FairnessScore')"
                        :total-steps="placeVariable('Level_Initiatives_FMax')" :start-color="'#3247b2'"
                        :stop-color="'#3247b2'" :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_fair_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_rows">
                      <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_Initiatives_FairnessScore'))
                      }}/{{
                          formatNumber(placeVariable('Level_Initiatives_FMax')) }}</div>
                      <div id="comp_scores_desc" v-html="tag('desc5')"></div>
                    </div>
                  </div>
                  <!--Equity Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_Initiatives_EquityScore')"
                        :total-steps="placeVariable('Level_Initiatives_EMax')" :start-color="'#32b285'"
                        :stop-color="'#32b285'" :animate-speed="800" :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_equit_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_rows">
                      <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_Initiatives_EquityScore')) }}/{{
                        formatNumber(placeVariable('Level_Initiatives_EMax')) }}</div>
                      <div id="comp_scores_desc" v-html="tag('desc6')"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Level 3-->
            <div id="comp_level_container">
              <div id="comp_level_title" v-html="tag('header5')"></div>
              <div id="comp_Level_KeyConsiderations__column">
                <div id="comp_Level_KeyConsiderations__row">
                  <div id="comp_Level_Initiatives__title" v-html="tag('Level_KeyConsiderations_title')"></div>
                  <div id="comp_Level_KeyConsiderations__rank-col">
                    <div id="comp_Level_KeyConsiderations__desc">1</div>
                    <div id="comp_Level_Initiatives__desc">{{ getAllScores()[0].priority }}</div>
                  </div>
                  <div id="comp_Level_KeyConsiderations__rank-col">
                    <div id="comp_Level_KeyConsiderations__desc">2</div>
                    <div id="comp_Level_Initiatives__desc">{{ getAllScores()[1].priority }}</div>
                  </div>
                  <div id="comp_Level_KeyConsiderations__rank-col">
                    <div id="comp_Level_KeyConsiderations__desc">3</div>
                    <div id="comp_Level_Initiatives__desc">{{ getAllScores()[2].priority }}</div>
                  </div>
                  <div id="comp_Level_KeyConsiderations__rank-col">
                    <div id="comp_Level_KeyConsiderations__desc">4</div>
                    <div id="comp_Level_Initiatives__desc">{{ getAllScores()[3].priority }}</div>
                  </div>
                  <div id="comp_Level_KeyConsiderations__rank-col">
                    <div id="comp_Level_KeyConsiderations__desc">5</div>
                    <div id="comp_Level_Initiatives__desc">{{ getAllScores()[4].priority }}</div>
                  </div>
                  <div id="comp_Level_KeyConsiderations__rank-col">
                    <div id="comp_Level_KeyConsiderations__desc">6</div>
                    <div id="comp_Level_Initiatives__desc">{{ getAllScores()[5].priority }}</div>
                  </div>
                  <div id="comp_Level_KeyConsiderations__rank-col">
                    <div id="comp_Level_KeyConsiderations__desc">7</div>
                    <div id="comp_Level_Initiatives__desc">{{ getAllScores()[6].priority }}</div>
                  </div>
                </div>
                <div id="comp_Level_KeyConsiderations__row">
                  <!--Relationship Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_KeyConsiderations_RelationshipScore')" :total-steps="9"
                        :start-color="'#b23256'" :stop-color="'#b23256'" :animate-speed="800"
                        :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_rela_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_rows">
                      <div id="comp_scores_title">{{
                        formatNumber(placeVariable('Level_KeyConsiderations_RelationshipScore'))
                      }}/9</div>
                      <div id="comp_scores_desc" v-html="tag('desc7')"></div>
                    </div>
                  </div>
                  <!--Fairness Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_KeyConsiderations_FairnessScore')" :total-steps="9"
                        :start-color="'#3247b2'" :stop-color="'#3247b2'" :animate-speed="800"
                        :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_fair_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_rows">
                      <div id="comp_scores_title">{{
                        formatNumber(placeVariable('Level_KeyConsiderations_FairnessScore')) }}/9
                      </div>
                      <div id="comp_scores_desc" v-html="tag('desc8')"></div>
                    </div>
                  </div>
                  <!--Equity Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_KeyConsiderations_EquityScore')" :total-steps="9"
                        :start-color="'#32b285'" :stop-color="'#32b285'" :animate-speed="800"
                        :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_equit_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_rows">
                      <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_KeyConsiderations_EquityScore'))
                      }}/9
                      </div>
                      <div id="comp_scores_desc" v-html="tag('desc9')"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Level 5-->
            <div id="comp_level_container">
              <div id="comp_level_title" v-html="tag('header7')"></div>
              <div id="comp_Level_StrategicApproach__column">
                <div id="comp_Level_StrategicApproach__row" v-html="tag('Level_StrategicApproach_desc')"></div>
                <div id="comp_Level_StrategicApproach__row">
                  <!--Relationship Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_StrategicApproach_RelationshipScore')" :total-steps="9"
                        :start-color="'#b23256'" :stop-color="'#b23256'" :animate-speed="800"
                        :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_rela_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_row">
                      <div id="comp_scores_title">{{
                        formatNumber(placeVariable('Level_StrategicApproach_RelationshipScore'))
                      }}/9</div>
                      <div id="comp_scores_desc" v-html="tag('desc10')"></div>
                    </div>
                  </div>
                  <!--Fairness Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_StrategicApproach_FairnessScore')" :total-steps="9"
                        :start-color="'#3247b2'" :stop-color="'#3247b2'" :animate-speed="800"
                        :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_fair_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_row">
                      <div id="comp_scores_title">{{
                        formatNumber(placeVariable('Level_StrategicApproach_FairnessScore')) }}/9
                      </div>
                      <div id="comp_scores_desc" v-html="tag('desc11')"></div>
                    </div>
                  </div>
                  <!--Equity Scores-->
                  <div id="comp_scores_row">
                    <div id="comp_ring">
                      <radial-progress :diameter="55" :stroke-width="4" :inner-stroke-width="4"
                        :inner-stroke-color="'#ffffff'"
                        :completed-steps="placeVariable('Level_StrategicApproach_EquityScore')" :total-steps="9"
                        :start-color="'#32b285'" :stop-color="'#32b285'" :animate-speed="800"
                        :timing-func="'cubic-bezier(.3,.5,.8,.6)'">
                        <div id="comp_equit_IMG"></div>
                      </radial-progress>
                    </div>
                    <div id="comp_desc_row">
                      <div id="comp_scores_title">{{ formatNumber(placeVariable('Level_StrategicApproach_EquityScore'))
                      }}/9
                      </div>
                      <div id="comp_scores_desc" v-html="tag('desc12')"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Level 4-->
            <div id="comp_level_container">
              <div id="comp_level_title" v-html="tag('header6')"></div>
              <div id="comp_Level_CulturalLicenseEval__column">
                <div id="comp_Level_CulturalLicenseEval__row" v-html="tag('Level_CulturalLicenseEval_desc')"></div>
                <div id="comp_Level_CulturalLicenseEval__row2">
                  <div id="comp_tiki_container">
                    <div id="comp_gold_IMG" v-if="variable('PlayerAward') == 'Gold'"></div>
                    <div id="comp_silver_IMG" v-if="variable('PlayerAward') == 'Silver'"></div>
                    <div id="comp_bronze_IMG" v-if="variable('PlayerAward') == 'Bronze'"></div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!--Statics-->
          <div id="default_background"></div>
        </div>

        <!--Failed to Gain Consent-->
        <div class="screen_size" id="animated_screen" v-if="tag('screentype') == 'consentfailure'">
          <div class="modal_background">
            <div id="fail_box">
              <div id="fail_title">{{ tag('header') }}</div>
              <div id="fail_desc_box">
                <div id="fail_desc" v-html="tag('description')"></div>
              </div>
              <div id="fail_BTN_box">
                <div id="fail_return_BTN" @click="doChoice(0)">
                  <div id="arrow_left_icon"></div>{{ storyChoices[0] }}
                </div>
                <div id="fail_restart_BTN" @click="doChoice(1)">{{ storyChoices[1] }}<div id="replay_icon"></div>
                  <!--</div>
                <div id="fail_forward_BTN" @click="doChoice(2)">{{ storyChoices[2] }}<div id="cont_icon"></div>-->
                </div>
              </div>
            </div>
          </div>
          <div id="default_background"></div>
        </div>

        <!--Game Over-->
        <div class="screen_size" id="animated_screen" v-if="tag('screentype') == 'GameOver'">
          <div class="modal_background">
            <div id="over_box">
              <div id="over_title">{{ tag('header') }}</div>
              <div id="over_desc_box">
                <div id="over_desc" v-html="tag('description')"></div>
              </div>
              <div id="over_BTN_box">
                <div id="over_return_BTN" @click="doChoice(1)">
                  <div id="arrow_left_icon"></div>{{ storyChoices[1] }}
                </div>
                <div id="over_restart_BTN" @click="doChoice(0)">{{ storyChoices[0] }}<div id="replay_icon"></div>
                </div>
              </div>
            </div>
          </div>
          <div id="default_background"></div>
        </div>

        <!-- default fall back div -->
        <div v-if="false">

          <div class="talk-pad" v-html="storyText"></div>

          <div class="tag-container full-screen-cover">
            <template v-bind:key="'tag' + key" v-for="(value, key) in tags">
              <div>
                {{ key }}:{{ value }}
              </div>
            </template>
          </div>

          <div class="variable-container full-screen-cover">
            <template v-bind:key="'variable' + key" v-for="(value, key) in variables">
              <div>
                {{ key }}:{{ value }}
              </div>
            </template>
          </div>

          <!-- click detector -->
          <div class="full-screen-cover" @click="doChoice(-1)">
          </div>

          <div class="option-overlay full-screen-cover" v-if="storyChoices.length > 0">
            <div class="option-overlay-bg full-screen-cover"></div>
            <div class="option-list full-screen-cover">
              <template v-bind:key="'choice' + index" v-for="(choice, index) of storyChoices">
                <div class="option" v-html="choice" @click="doChoice(index)"></div>
              </template>
            </div>
          </div>

          <div class="button-container full-screen-cover">
            <div class="button" @click="goBack()">Go Back</div>
            <div class="button" @click="restartStory(null)">Restart Story</div>
            <form class="button" method="post" enctype="multipart/form-data">
              <input name="file" type="file" @change="uploadFile">
            </form>
          </div>

          <div class="path-text-container full-screen-cover">
            <div class="path-text" v-html="pathString"></div>
          </div>

        </div>

      </div>


    </div>
  </div>

</template>


<script lang="ts">
import { defineComponent, ref } from 'vue';
import storyImport from "./story/story.json";
import { Story } from 'inkjs/engine/Story';
import "@fontsource/inter"; // Defaults to weight 400
import analytics from "./analytics";

const analyticsManager = new analytics("https://asia-southeast1-geoar-analytics.cloudfunctions.net/API/", "54769d61-fa79-4cbe-aa7d-608aadc346ae", "dsi");

class appData {

  story: Story | null = null;
  storySource: any = {};
  storyText = "";
  overrideStoryText = "";
  storyChoices: string[] = [];
  tags: { [id: string]: string } = {};
  variables: { [id: string]: string } = {};
  path: number[] = [];
  px_ratio = 0;
  zoom = 1;

  surveyNextClicked = 0;

  functionCache: { [id: string]: string } = {};

}


const referenceWidth = 1920;
const referenceHeight = 1080;

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import RadialProgress from "vue3-radial-progress";
import { Tippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';

export default defineComponent({
  name: 'App',
  data() {
    return new appData();
  },

  components: {
    VueSlider,
    RadialProgress,
    Tippy,
  },

  computed: {

    radioNextDisabled(): boolean {
      return !this.leastValue || !this.mostValue;
    },

    leastValue(): string {
      return this.getVariable("LeastImportant");
    },

    mostValue(): string {
      return this.getVariable("MostImportant");
    },

    friendlyName(): string {

      const speaker = this.tag('speaker');
      return this.tag(speaker + "_name");

    },

    description(): string {

      const speaker = this.tag('speaker');
      return this.tag(speaker + "_description");

    },

    pathString() {
      let result = "";
      for (let i = 0; i < this.path.length; i++) {
        result += this.path[i] + 1;
      }
      return result;
    },

    playerName: {
      get(): string {
        return this.getVariable('playername');
      },
      set(value: string) {
        this.setVariable('playername', value);
      }
    },

    scenarioBudgetAssigned: {
      get(): number {
        return this.getNumberVariable('ScenarioBudgetAssigned');
      },
      set(value: number) {
        this.setVariable('ScenarioBudgetAssigned', value);
      }
    },

  },

  mounted() {

    this.storySource = storyImport;
    this.restartStory(null);
    this.px_ratio =
      window.devicePixelRatio ||
      window.screen.availWidth / document.documentElement.clientWidth;

    requestAnimationFrame(this.resized);

    this.resized();

  },

  methods: {

    submitForm(e: SubmitEvent) {

      const formData = Object.fromEntries(new FormData(e.currentTarget as HTMLFormElement));

      const outData: { [key: string]: string } = {};
      for (const key of Object.keys(formData)) {
        outData[key] = formData[key] + ""; //Convert everything to string
      }

      analyticsManager.Post("Game", "Demographics", 0, [outData["quest_eth"]], outData);
      this.doChoice(0);

    },

    surveyNext() {

      this.surveyNextClicked++;
      this.leastValue = "";
      this.mostValue = "";
      this.doChoice(6);

    },

    //methods for getting and setting a variable using the native Ink API
    getVariable(variableName: string): string {
      if (!this.story) {
        return "";
      }
      const value = this.story.variablesState.$(variableName);
      if (value) {
        return value.toString();
      }
      return "";
    },

    setVariable(variableName: string, value: string | number): void {
      if (!this.story) {
        return;
      }
      this.story.variablesState.$(variableName, value);
    },

    formatNumber(value: number): string {
      return value.toLocaleString("en");
    },

    getNumberVariable(variableName: string): number {
      const value = this.getVariable(variableName);
      if (!value) {
        return 0;
      }
      return parseInt(value, 10);

    },

    resized(): void {

      requestAnimationFrame(this.resized);

      const gameWindow = document.getElementById("window");
      if (!gameWindow) {
        return;
      }

      const newPx_ratio =
        window.devicePixelRatio || window.screen.availWidth / window.innerWidth;

      let zoomScale = newPx_ratio / this.px_ratio;

      let scale = window.innerHeight / referenceHeight;
      this.zoom = scale * zoomScale;
      const newTransform = "scale(" + this.zoom + ")";

      let newWidth = "";

      if (window.innerWidth > window.innerHeight) {
        newWidth = window.innerWidth / scale + "px";
      } else {
        const adjustedHeight = window.innerHeight / scale;
        newWidth = adjustedHeight * (referenceWidth / referenceHeight) + "px";
      }

      gameWindow.style.transform = newTransform + " translate(-50%,0)";

    },

    tag(key: string): string {

      key = key.trim().toLowerCase();
      if (!this.tags[key]) {
        return "";
      }
      return this.tags[key];

    },

    variable(key: string): string {

      key = key.trim().toLowerCase();
      if (!this.variables[key]) {
        return "";
      }
      return this.variables[key];
    },

    //returns variable as number
    intVariable(key: string): number {

      const value = this.variable(key);
      if (!value) {
        return 0;
      }
      return parseInt(value, 10);

    },

    //returns variable as floating number
    floatVariable(key: string): number {

      const value = this.variable(key);
      if (!value) {
        return 0;
      }
      return parseFloat(parseFloat(value).toFixed(2));

    },

    //returns variable as floating number
    placeVariable(key: string): number {

      const value = this.variable(key);
      if (!value) {
        return 0;
      }
      return parseFloat(parseFloat(value).toFixed(0));

    },

    uploadFile(arg1: any) {
      arg1.target.files[0].text().then((text: string) => {
        this.storySource = JSON.parse(text);
        this.restartStory(null);
      });
    },

    surveyURL() {
      return "https://docs.google.com/forms/d/e/1FAIpQLSffd244hVCnnjxy02UlMNKZbnCBSzp4bz3pT2MMZJ-uU3CbbQ/viewform?usp=pp_url&entry.852708749=" + analyticsManager.SessionID;
    },

    sendScores(stage: number, relationship: number, fairness: number, equity: number, Award: string, Approach: string) {

      analyticsManager.Post("Game", "Scores", relationship + fairness + equity, ["Stage " + stage], {
        Relationship: relationship + "",
        Fairness: fairness + "",
        Equity: equity + "",
        Award,
        Approach,
      });

    },

    sendMostLeastImportant(id: number, mostImportant: string, midImportant: string, leastImportant: string) {

      analyticsManager.Post("Game", "BestWorstMostLeast", id, [], {
        mostImportant, midImportant, leastImportant
      });

    },

    sendBudget(allocated: number, total: number) {

      analyticsManager.Post("Game", "Budget", allocated, [], {
        allocated: allocated + "",
        total: total + "",
        percentage: ((allocated * 100) / total) + "%"
      });

    },

    sendBudgetAllocated(
      CountStudent: number,
      CountIntern: number,
      CountMasters: number,
      CountPhD: number,
      CountCommunityMeeting: number,
      CountSmallWorkshop: number,
      CountCommunityEvent: number,
      CountCapacityBuildingProgram: number,
      CountCommunityAdvisoryGroup: number,
      CountConsultant: number,
      CountPartTimeResearcher: number,
      CountFullTimeResearcher: number) {

      analyticsManager.Post("Game", "BudgetInitiatives", 0, [], {

        CountStudent: CountStudent + "",
        CountIntern: CountIntern + "",
        CountMasters: CountMasters + "",
        CountPhD: CountPhD + "",
        CountCommunityMeeting: CountCommunityMeeting + "",
        CountSmallWorkshop: CountSmallWorkshop + "",
        CountCommunityEvent: CountCommunityEvent + "",
        CountCapacityBuildingProgram: CountCapacityBuildingProgram + "",
        CountCommunityAdvisoryGroup: CountCommunityAdvisoryGroup + "",
        CountConsultant: CountConsultant + "",
        CountPartTimeResearcher: CountPartTimeResearcher + "",
        CountFullTimeResearcher: CountFullTimeResearcher + "",

        Student: (CountStudent * 5000) + "",
        Intern: (CountIntern * 10000) + "",
        Masters: (CountMasters * 20000) + "",
        PhD: (CountPhD * 40000) + "",
        CommunityMeeting: (CountCommunityMeeting * 2500) + "",
        SmallWorkshop: (CountSmallWorkshop * 5000) + "",
        CommunityEvent: (CountCommunityEvent * 10000) + "",
        CapacityBuildingProgram: (CountCapacityBuildingProgram * 20000) + "",
        CommunityAdvisoryGroup: (CountCommunityAdvisoryGroup * 10000) + "",
        Consultant: (CountConsultant * 20000) + "",
        PartTimeResearcher: (CountPartTimeResearcher * 40000) + "",
        FullTimeResearcher: (CountFullTimeResearcher * 80000) + "",

      });

    },

    sendBestWorstSurvey() {

      const results = this.getAllScores();

      /*
      const data: { [key: string]: string } = {};
      for (let i = 0; i < results.length; i++) {
        data["Result " + (i + 1)] = results[i].priority;
      }
        */

      const data: string[] = [];
      for (let i = 0; i < results.length; i++) {
        data.push(results[i].priority);
      }

      analyticsManager.Post("Game", "BestWorst", 0, data);

    },

    restartStory(path: number[] | null) {

      this.tags = {};
      this.variables = {};
      this.path = [];
      this.story = new Story(this.storySource);

      //bindings
      this.story.BindExternalFunction("SendBestWorstSurvey", () => this.sendBestWorstSurvey());
      this.story.BindExternalFunction("SendScores", (stage, relationship, fairness, equity, award, approach) => this.sendScores(stage, relationship, fairness, equity, award, approach));
      this.story.BindExternalFunction("SendBudget", (allocated, total) => this.sendBudget(allocated, total));
      this.story.BindExternalFunction("SendMostLeastImportant", (id, most, mid, least) => this.sendMostLeastImportant(id, most, mid, least));

      this.story.BindExternalFunction("SendBudgetAllocated",
        (student, interns, masters, phd, communityMeeting, smallWorkshop, communityEvent, program, advisor, consultant, partTime, fullTime) => this.sendBudgetAllocated(student, interns, masters, phd, communityMeeting, smallWorkshop, communityEvent, program, advisor, consultant, partTime, fullTime));

      this.story.BindExternalFunction("SetDialogue", (text) => {
        this.overrideStoryText = text;
      });

      this.story.BindExternalFunction("RefreshBrowser", () => {
        location.reload();
      });

      this.continueStory();

      if (path && path.length) {

        for (let i = 0; i < path.length; i++) {
          this.doChoice(path[i]);
        }
      }


    },

    goBack() {

      const newPath = this.path;
      newPath.pop(); //Ditch the last choice
      this.restartStory(newPath);

    },

    refreshTagsAndVariables() {
      if (!this.story) {
        return;
      }
      for (const variable of this.story.variablesState._globalVariables) {
        this.variables[variable[0].trim().toLowerCase()] = variable[1].value;
      }
      if (this.story.currentTags) {
        for (const tag of this.story.currentTags) {

          const split = tag.replace("=", ":").split(":");
          if (split.length < 2) {
            continue;
          }

          this.tags[split[0].trim().toLowerCase()] = split[1].trim();
        }
      }

    },

    //Runs a function (should only be used for language)
    e(id: string): string {

      if (!this.functionCache[id]) {
        this.functionCache[id] = this.story?.EvaluateFunction(id);
      }
      return this.functionCache[id];

    },

    clearFunctionCache() {
      this.functionCache = {};
    },

    continueStory() {

      this.clearFunctionCache();

      //Clear the list of choices
      this.storyChoices.length = 0;

      //Invalid or finished story
      if (!this.story || (this.story.canContinue == false && this.story.currentChoices.length == 0)) {
        return;
      }

      if (this.story.canContinue) {

        this.storyText = "";
        while (this.storyText == "" && this.story.canContinue) {
          this.storyText = (this.story.Continue() ?? "").trim();
          this.refreshTagsAndVariables();
        }

        if (this.storyText != "") {
          return;
        }

        this.storyText = this.overrideStoryText;
        this.overrideStoryText = "";
      }

      this.refreshTagsAndVariables();
      for (let i = 0; i < this.story.currentChoices.length; i++) {
        this.storyChoices.push(this.story.currentChoices[i].text);
      }

    },


    doContinue() {

      //Make sure we have no available choices
      if (this.story && this.storyChoices.length > 0) {
        return;
      }

      this.doChoice(-1);

    },

    choiceHeader(index: number): string {
      if (this.storyChoices.length <= index) {
        return "";
      }
      return this.storyChoices[index].split("~")[0];
    },

    choiceDescription(index: number): string {
      if (this.storyChoices.length <= index || this.storyChoices[index].indexOf("~") == -1) {
        return "";
      }
      return this.storyChoices[index].split("~")[1];
    },

    selectScenario(scenario: number) {

      analyticsManager.Post("Game", "Scenario", scenario, [this.tag("header" + scenario).replace("<br>", " ")]);
      this.doChoice(scenario - 1); //zero indexed

    },

    //Changed to only support a number - string is unreliable due to script changes and translations
    doChoice(index: number) {
      if (!this.story) {
        return;
      }

      this.clearFunctionCache();

      /*
      let index = 0;
      if (typeof (value) === "number") {
        index = value;
      }
      else {
        index = this.storyChoices.indexOf(value);
        if (index == -1) {
          throw new Error("Unknown story choice: " + value);
        }
      }
        */

      this.path.push(index);

      if (index > -1) {
        this.story.ChooseChoiceIndex(index);

        //Record this choice
        if (this.story.currentText) {

          let data = {
            unselectedChoices: "",
            storyText: this.story.currentText,
          };

          const allChoices: { [key: string]: boolean } = {}
          const unselectedChoices: string[] = [];

          for (let i = 0; i < this.storyChoices.length; i++) {

            const choice = this.storyChoices[i];
            if (allChoices[choice]) {
              continue;
            }
            allChoices[choice] = true;

            if (i == index) {
              continue;
            }
            unselectedChoices.push(choice);

          }


          if (Object.keys(allChoices).length > 1) {
            //Only interested if we have more than one choice to have selected from
            data.unselectedChoices = unselectedChoices.join("|");
            analyticsManager.Post("Game", "Decision", 0, [this.storyChoices[index]], data);
          }

        }

      }
      this.continueStory();

    },

    mostCount(priority: string): number {

      let result = 0;
      for (let i = 1; i <= 7; i++) {
        if (this.getVariable("MostImportant" + i) == priority) {
          result++;
        }
      }
      return result;

    },

    leastCount(priority: string): number {

      let result = 0;
      for (let i = 1; i <= 7; i++) {
        if (this.getVariable("LeastImportant" + i) == priority) {
          result++;
        }
      }
      return result;

    },

    score(priority: string): number {

      // Weighted best for each attribute  = 4 * Freq (best) + Freq (worst). 
      const best = 4 * this.mostCount(priority) + this.leastCount(priority);

      //Weighted worst = 4 * Freq (worst) + Freq (best).
      const worst = 4 * this.leastCount(priority) + this.mostCount(priority);

      //Then calculate Best (weighted) - Worst (weighted)
      return best - worst;

      //Old formula
      //return (this.mostCount(priority) - this.leastCount(priority)) / 3;

    },

    getAllScores(): priorityScore[] {

      let result: priorityScore[] = [];

      for (let i = 1; i <= 7; i++) {
        const priority = this.getVariable("Priority" + i);
        const definition = this.getVariable("Definition" + i);
        result.push({
          priority,
          definition,
          score: this.score(priority),
        });
      }

      result.sort((a, b) => (a.score > b.score ? -1 : 1));
      return result;

    }


  }
});

interface priorityScore {
  priority: string;
  score: number;
  definition: string;
}

</script>

<style lang="scss">
#app {
  transform-origin: top;
  background-image: linear-gradient(rgba(148, 170, 211, 1), rgba(97, 95, 173, 1));
  width: 100%;
  height: 100%;
  position: absolute;
  font-family: "Inter";
}

#windowWrapper {
  height: 0px;
}

#window {
  width: 1920px;
  height: 1080px;
  transform-origin: top left;
  //  overflow-x: hidden !important;
  //  overflow-y: hidden !important;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
}

.gradient-background {
  background-image: linear-gradient(rgba(148, 170, 211, 1), rgba(97, 95, 173, 1));
}

.full-screen-cover {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

.full-game {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.default_screen {
  background-image: url(./assets/backgrounds/Background_Default.png);
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 0;
  width: 1920px;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}

html {
  overflow: hidden;
}

//Splash set ups
.splash_container {
  background-color: #ffffff;

  position: absolute;
  top: 0px;
  left: -200%;
  right: -200%;
  bottom: 0px;
  z-index: 50;

  animation-name: fade-container;
  animation-duration: 8s;
  animation-delay: 0.5s;
  animation-fill-mode: both;
}

#geo_logo {
  background-image: url(./assets/company_logos/GeoAR_Orange.png);
  background-size: 100%;
  background-repeat: no-repeat;

  position: absolute;
  width: 500px;
  top: 40%;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);

  animation-name: logo-fade;
  animation-duration: 2s;
  animation-delay: 0.5s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(.3, .5, .8, .6);
}

#nz_on_air_GDSR_logo {
  background-image: url(./assets/company_logos/NZoA_RGB_Game_Sector_Logo.png);
  background-size: 100%;
  background-repeat: no-repeat;

  position: absolute;
  width: 800px;
  top: 20%;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);

  animation-name: logo-fade;
  animation-duration: 2s;
  animation-delay: 5.5s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(.3, .5, .8, .6);
}

#waikato_logo {
  background-image: url(./assets/company_logos/UoW_logo.png);
  background-size: 100%;
  background-repeat: no-repeat;

  position: absolute;
  width: 800px;
  top: 20%;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);

  animation-name: logo-fade;
  animation-duration: 2s;
  animation-delay: 3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(.3, .5, .8, .6);
}

#kotahi_logo {
  background-image: url(./assets/company_logos/Te_Kotahi_logo.png);
  background-size: 100%;
  background-repeat: no-repeat;

  position: absolute;
  width: 800px;
  top: 50%;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);

  animation-name: logo-fade;
  animation-duration: 2s;
  animation-delay: 3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(.3, .5, .8, .6);
}

@keyframes logo-fade {
  0% {
    opacity: 0;
  }

  30% {
    opacity: 100;
  }

  70% {
    opacity: 100;
  }

  100% {
    opacity: 0;
  }
}

@keyframes fade-container {
  0% {
    opacity: 100;
  }

  99% {
    opacity: 100;
    z-index: 6;
  }

  100% {
    opacity: 0;
    z-index: -5;
  }
}

//Backgrounds and universals
.screen_size {
  position: absolute;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

#default_background {
  background-image: url(./assets/backgrounds/Background_Default.png);
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 0;
  width: 1920px;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}

#meeting_background {
  background-image: url(./assets/backgrounds/Background_MeetingHouse.png);
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 0;
  width: 1920px;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}

#gov_background {
  background-image: url(./assets/backgrounds/Background_GovtOffice.png);
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 0;
  width: 1920px;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}

#board_background {
  background-image: url(./assets/backgrounds/Background_Boardroom.png);
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 0;
  width: 1920px;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}

.modal_background {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 6;
}

#confirm_modal_title {
  display: flex;
  position: absolute;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  min-width: 437px;
  width: max-content;
  height: 66px;
  top: 5%;

  background: #48649F;
  color: #EEEEEE;
  font-size: 40px;
  font-weight: 700;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#cont_BTN_style {
  min-width: 188px;
  width: max-content;
  height: 34px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
}

#cont_BTN_style:hover {
  background: #7570A5;
  cursor: pointer;
}

#cont_BTN_style_onBut {
  all: unset;
  width: 188px;
  height: 34px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
}

#cont_BTN_style_onBut:hover {
  background: #7570A5;
  cursor: pointer;
}

#cont_BTN {
  font-weight: 700;
  font-size: 22px;
  text-align: center;
  color: #EEEEEE;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#cont_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/arrow-right_icon.png);
  background-size: 24px;

  flex: none;
  order: 2;
  flex-grow: 0;
}

#cross_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/cross_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#check_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/check_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#arrow_left_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/arrow-left_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;
}

#arrow_down_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/arrow-down_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;

  flex: none;
  order: 2;
  flex-grow: 0;
}

#replay_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/replay_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;
}

#sub_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/minus_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;
}

#add_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/plus_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;
}

#schol_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/education_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;
}

#comm_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/community_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;
}

#indi_icon {
  width: 24px;
  height: 24px;
  background-image: url(./assets/game_icons/research_icon.png);
  background-repeat: no-repeat;
  background-size: 24px;
}

#card_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 16px;

  width: 450px;
  height: max-content; //632px

  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  z-index: 5;

  flex: none;
  order: 0;
  flex-grow: 0;

  transition: transform 0.2s;
  transition-timing-function: ease-in-out;
}

#card_hover_wrap:hover #card_box {
  transform: translate(0px, -20px);
  outline-style: solid;
  outline-color: #FFA400;
  outline-width: 5px;
}

#card_IMG {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 0px;
  gap: 8px;

  width: 448px;
  height: 240px;
  border-radius: 8px;
  background: #BE5870;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#card_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 8px 16px;
  gap: 8px;

  width: 416px;
  max-width: 448px;
  height: max-content;

  background: #48649F;
  color: #EEEEEE;
  font-size: 32px;
  font-weight: 700;
  text-align: center;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  transition: all 0.2s;
  transition-timing-function: ease-in-out;
}

#card_hover_wrap:hover #card_title {
  background-color: #FFA400;
  color: #000000;
}

#card_desc {
  width: 448px;
  height: max-content; //150px
  margin: auto;

  font-weight: 400;
  font-size: 22px;
  color: #000000;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
}

#card_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 390px;
  height: 32px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  color: #EEEEEE;
  font-size: 22px;
  font-weight: 700;

  flex: none;
  order: 2;
  flex-grow: 0;
}

#card_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#encompassing_dialogue_box {
  display: flex;
  flex-direction: row;

  z-index: 5;
}

#dialogue_container {
  display: flex;
  flex-direction: row;
  //justify-content: center;
  align-items: center;
  padding: 24px 24px 32px;
  gap: 8px;
  isolation: isolate;

  width: 810px;
  height: max-content;
  margin-top: 30px;

  background: #44474F;
  filter: drop-shadow(0px 2px 0px rgba(0, 0, 0, 0.25));
  border-radius: 0px 20px 20px 20px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  transition: all 0.2s;
  transition-timing-function: ease-in-out;
}

#dialogue_box {
  display: inline;
  width: 100%;

  font-size: 22px;
  text-align: left;
  color: #EEEEEE;

  flex: auto;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  transition: all 0.2s;
  transition-timing-function: ease-in-out;
}

#encompassing_dialogue_box:hover #dialogue_container {
  background: #ffffff;
  transform: translate(3%);
  cursor: pointer;
}

#encompassing_dialogue_box:hover #dialogue_box {
  color: #000000;
}

#encompassing_dialogue_box:hover #dialogue_title {
  background: #FFA400;
  color: #000000;
  transform: translate(25px);
}

#encompassing_dialogue_box:hover a {
  color: #48649F;
}

#dialogue_title {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 4px 8px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 38px;
  left: 2%;

  background: #48649F;
  border-radius: 4px;
  font-size: 22px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 1;

  transition: all 0.2s;
  transition-timing-function: ease-in-out;
}

#speaker_name {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 58px;
  top: 774px;
  right: 5%;
  z-index: 5;

  background: #FFA400;
  border-radius: 8px;
  font-size: 40px;
  font-weight: 700;
  color: #000000;
}

#speaker_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 38px;
  top: 828px;
  right: 4%;
  z-index: 4;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 22px;
  color: #000000;
}

//End of backgrounds and universals

//Main Menu styles
#menu_title {
  position: absolute;
  width: 750px;
  height: 350px;
  top: 10%;
  left: 10%;
  z-index: 5;

  background-image: url(./assets/game_logos/BenefitSharingCompass_Logo_White.svg);
  background-size: 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 4px 0px rgb(0, 0, 0, 0.25));
}

#menu_qr {
  position: absolute;
  width:256px;
  height: 256px;
  top: 62%;
  left: 37%;
  z-index: 8;

  background-image: url(./assets/waikato_QR_indigenousbiodiscovery.png);
  background-size: 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 4px 0px rgb(0, 0, 0, 0.25));
}

#menu_desc {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 8px;

  position: absolute;
  width: 909px;
  height: 70px;
  top: 671px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 30px;
  font-weight: 700;
  color: #EEEEEE;
}

#menu_BTN_div {
  position: absolute;
  display: grid;
  row-gap: 24px;
  top: 50%;
  left: 12%;
  z-index: 5;
}

#legals_BTN_div {
  position: absolute;
  display: flex;
  column-gap: 8px;
  grid-row: 4;
  top: 24px;
  left: 0%;
  z-index: 5;
}

#menu_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 48px;
  gap: 8px;

  width: 390px;
  height: 36px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  flex: none;
  order: 0;
  flex-grow: 0;

  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #EEEEEE;
}

#language_BTN {
  display: flex;
  flex-direction: grid;
  justify-content: center;
  align-items: center;
  padding: 16px 48px;
  gap: 8px;

  width: 390px;
  height: 36px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
}

#resource_BTN {
  display: flex;
  flex-direction: grid;
  justify-content: center;
  align-items: center;
  padding: 16px 48px;
  gap: 8px;

  width: 390px;
  height: 36px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #EEEEEE;
}

#privacypolicy_BTN {
  display: flex;
  flex-direction: grid;
  justify-content: center;
  align-items: center;
  padding: 16px 48px;
  gap: 8px;

  width: fill;
  height: 36px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  font-weight: 700;
  font-size: 24px;
  text-align: center;
  color: #EEEEEE;
}

#privacypolicy_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#termsconditions_BTN {
  display: flex;
  flex-direction: grid;
  justify-content: center;
  align-items: center;
  padding: 16px 48px;
  gap: 8px;

  width: fill;
  height: 36px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  font-weight: 400;
  font-size: 24px;
  text-align: center;
  color: #EEEEEE;
}

#termsconditions_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#bugreport_BTN {
  display: flex;
  flex-direction: grid;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 8px;

  position: relative;
  width: fit-content;
  height: 36px;
  z-index: 9;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  font-weight: 400;
  font-size: 18px;
  text-align: center;
  color: #EEEEEE;
}

#bugreport_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#menu_language_text {
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #EEEEEE;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#legals_button_text {
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  color: #EEEEEE;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#menu_play_icon {
  width: 40px;
  height: 40px;
  background: url(./assets/game_icons/play_icon.png);
  background-size: 40px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#language_icon {
  width: 40px;
  height: 40px;
  background: url(./assets/game_icons/language_icon.png);
  background-size: 40px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#externallink_icon {
  width: 40px;
  height: 40px;
  background: url(./assets/game_icons/externallink_icon.png);
  background-size: 40px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#externallink_dark_icon {
  width: 40px;
  height: 40px;
  background: url(./assets/game_icons/externallink_dark_icon.png);
  background-size: 40px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#bugreport_icon {
  width: 32px;
  height: 32px;
  background: url(./assets/game_icons/bug_report.png);
  background-size: 32px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#menu_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#language_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#resource_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

.menu_images {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0px;

  position: absolute;
  width: 981px;
  height: 881px;
  //background-color: #32B285;

  top: 371px;
  left: 47%;
  z-index: 5;
}

#menu_jasmine {
  position: absolute;
  width: 337px;
  height: 784px;
  top: 70px;
  left: 1150px;
  z-index: 4;

  background: url(./assets/characters/CharacterSprite_JasmineStrong_Alt.png);

  flex: none;
  order: 0;
  flex-grow: 0;
}

#menu_minister {
  position: absolute;
  width: 407px;
  height: 837px;
  top: 20px;
  left: 1650px;
  z-index: 4;

  background: url(./assets/characters/CharacterSprite_MinisterLong_Alt.png);

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0px -167px;
}

#menu_rawiri {
  width: 455px;
  height: 843px;

  background: url(./assets/characters/CharacterSprite_Rawiri_Alt.png);

  flex: none;
  order: 2;
  flex-grow: 0;
}

#menu_tribe1 {
  width: 483px;
  height: 881px;

  background: url(./assets/characters/CharacterSprite_TirbalLeader1_Alt.png);

  flex: none;
  order: 3;
  flex-grow: 0;
  margin: 0px -167px;
}

#menu_tribe2 {
  width: 415px;
  height: 855px;

  background: url(./assets/characters/CharacterSprite_TirbalLeader2_Alt.png);

  flex: none;
  order: 4;
  flex-grow: 0;

}

#menu_researcher {
  width: 502px;
  height: 841px;

  background: url(./assets/characters/CharacterSprite_Researcher_Alt.png);

  flex: none;
  order: 5;
  flex-grow: 0;
  margin: 0px -167px;
}

#menu_background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(./assets/backgrounds/Background_MainMenu.png);
  background-size: 100%;
  z-index: 1;
}

#language_BTN_div {
  position: absolute;
  display: grid;
  row-gap: 30px;
  top: 12%;
  right: 20%;
  z-index: 5;
}

#language_option_BTN {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 8px;
  gap: 8px;

  width: 280px;
  height: 36px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
}

#language_option_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#language_option_text {
  display: flex;
  flex: none;
  order: 1;

  font-weight: 700;
  font-size: 30px;
  text-align: left;
  color: #EEEEEE;
}

#maori_icon {
  width: 55px;
  height: 55px;
  display: flex;
  flex: none;
  order: 0;

  background: url(./assets/Flags/maori_icon.png);
  background-size: 55px;
  border-radius: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#spanish_icon {
  width: 55px;
  height: 55px;
  display: flex;
  flex: none;
  order: 0;

  background: url(./assets/Flags/spain_icon.png);
  background-size: 55px;
  border-radius: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#french_icon {
  width: 55px;
  height: 55px;
  display: flex;
  flex: none;
  order: 0;

  background: url(./assets/Flags/france_icon.png);
  background-size: 55px;
  border-radius: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#UK_icon {
  width: 55px;
  height: 55px;
  display: flex;
  flex: none;
  order: 0;

  background: url(./assets/Flags/UK_icon.png);
  background-size: 55px;
  border-radius: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#german_icon {
  width: 55px;
  height: 55px;
  display: flex;
  flex: none;
  order: 0;

  background: url(./assets/Flags/germany_icon.png);
  background-size: 55px;
  border-radius: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#brazil_icon {
  width: 55px;
  height: 55px;
  display: flex;
  flex: none;
  order: 0;

  background: url(./assets/Flags/brazil_icon.png);
  background-size: 55px;
  border-radius: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#italian_icon {
  width: 55px;
  height: 55px;
  display: flex;
  flex: none;
  order: 0;

  background: url(./assets/Flags/italy_icon.png);
  background-size: 55px;
  border-radius: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
}

//End of Menu

//Policies section
#policy_container {
  position: absolute;
  width: 1152px;
  height: 100%;
  left: 50%;
  top: 0px;
  transform: translate(-50%);
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  z-index: 5;
}

#policy_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0px 160px;
  gap: 32px;

  position: absolute;
  width: 1152px;
  height: max-content;
  left: 0px;
  top: 0px;
}

#policy_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  gap: 8px;

  width: max-content;
  height: 92px;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  flex: none;
  order: 0;
  flex-grow: 0;

  font-weight: 800;
  font-size: 60px;
  line-height: 76px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
}

#policy_text_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 64px 64px;
  //gap: 32px;

  width: 88%;
  height: max-content;
  background-color: #FFFFFF;
  border-radius: 20px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#policy_desc {
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #000000;

  margin-bottom: 32px;
}

#policy_subtitle {
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  color: #000000;

  margin-bottom: 8px;
}

#policy_buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  position: absolute;
  width: 438px;
  height: 64px;
  left: 50%;
  top: 957px;
  transform: translate(-50%);
  z-index: 5;
}

//End of policies

//Introduction to game
#intro_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  gap: 8px;

  position: absolute;
  min-width: 1320px;
  width: max-content;
  height: 146px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  font-size: 90px;
  font-weight: 700;
  color: #000000;
  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
}

#intro_desc_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 8px 16px;
  gap: 40px;

  position: absolute;
  width: 800px;
  height: max-content;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  z-index: 5;
}

#intro_box_title {
  width: 700px;
  height: 76px;
  margin-left: -2%;
  margin-top: 1%;

  font-weight: 700;
  font-size: 30px;
  text-align: left;
  display: flex;
  color: #48649F;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#intro_box_desc {
  width: 685px;
  //height: 390px;
  margin-left: -3%;
  margin-top: -8%;

  font-weight: 400;
  font-size: 22px;
  text-align: left;
  color: #000000;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#intro_cont_pos {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

#intro_char_IMG {
  position: absolute;
  width: 1139px;
  height: 918px;
  top: 190px;
  left: 41%;

  background: url(./assets/characters/CharacterSprite_TirbalLeaders_Alt.png);
  background-repeat: no-repeat;
  z-index: 4;
}

//End of introduction to game

//Study participation and data protection
#data_proc_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 8px 16px;
  gap: 40px;

  position: absolute;
  width: 600px;
  height: 230px;
  top: 244px;
  left: 13%;
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

#data_title {
  width: 329px;
  height: 38px;
  font-weight: 700;
  font-size: 30px;
  display: flex;
  align-items: center;

  margin-left: 2%;
  color: #48649F;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#data_desc {
  width: 558.27px;
  height: 30px;
  font-weight: 400;
  font-size: 22px;

  margin-left: 2%;
  color: #000000;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#data_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 300px;
  height: 34px;
  margin: auto;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  font-size: 22px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 2;
  flex-grow: 0;
}

#data_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#study_part_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 8px 16px;
  gap: 40px;

  position: absolute;
  width: 600px;
  height: 300px;
  top: 518px;
  left: 13%;
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

#study_title {
  width: 329px;
  height: 38px;
  font-weight: 700;
  font-size: 30px;
  display: flex;
  align-items: center;

  margin-left: 2%;
  color: #48649F;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#study_desc {
  width: 558.27px;
  height: 240px;

  font-weight: 400;
  font-size: 22px;

  margin-left: 2%;
  color: #000000;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#study_BTN_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  position: absolute;
  width: 542.27px;
  height: 64px;
  top: 874px;
  left: 16.5%;
  z-index: 5;
}

#no_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 200px;
  height: 34px;

  background: #BE5870;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  font-size: 22px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#no_BTN:hover {
  background: #E1251B;
  cursor: pointer;
}

#yes_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 200px;
  height: 34px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  font-size: 22px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#yes_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

//End of study and data styles

//Data protection modal popup
#data_modal_box {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 16px;
  gap: 16px;
  isolation: isolate;

  position: relative;
  width: 678px;
  height: 400px;
  margin: auto;
  top: 50%;
  transform: translate(0, -50%);

  background: #FFFFFF;
  border-radius: 20px 20px 0px 20px;
}

#data_modal_title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;

  width: 337px;
  height: 66px;

  background: #48649F;
  color: #EEEEEE;
  font-size: 40px;
  font-weight: 700;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#data_modal_desc {
  width: 560px;
  height: 168px;

  font-weight: 400;
  font-size: 22px;
  color: #000000;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#data_modal_okay_BTN {
  width: 550px;
  height: 34px;
  font-size: 22px;
  font-weight: 700;
  color: #EEEEEE;

  position: absolute;
  top: 78%;

  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
}

#data_modal_okay_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#data_modal_close_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;

  position: absolute;
  width: 64px;
  height: 64px;
  right: -16px;
  top: -16px;

  background: #BE5870;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 41px;

  flex: none;
  order: 3;
  flex-grow: 0;
  z-index: 3;
}

#data_modal_close_BTN:hover {
  background: #E1251B;
  cursor: pointer;
}

//End of data modal popup

//Start of Study Participation Modal Popup
#study_modal_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 32px;
  isolation: isolate;
  margin: auto;
  top: 50%;
  transform: translate(0, -50%);

  position: relative;
  width: 640px;
  height: 258px;

  background: #FFFFFF;
  border-radius: 20px 20px 0px 20px;
}

#study_modal_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  top: 5%;

  width: 301px;
  height: 66px;
  position: absolute;

  background: #48649F;
  font-size: 40px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#study_modal_desc {
  width: 560px;
  height: 168px;
  position: absolute;
  top: 32%;
  margin: auto;
  top: 42%;

  font-weight: 400;
  font-size: 22px;
  color: #000000;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#study_modal_BTN_box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;

  width: 608px;
  height: 64px;
  position: absolute;
  top: 70%;

  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;
}

#study_modal_return_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 192px;
  height: 34px;
  color: #EEEEEE;
  font-size: 22px;
  font-weight: 700;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  flex: none;
  order: 0;
  flex-grow: 1;
}

#study_modal_return_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#study_modal_cancel_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 192px;
  height: 34px;
  color: #EEEEEE;
  font-size: 22px;
  font-weight: 700;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  flex: none;
  order: 1;
  flex-grow: 1;
}

#study_modal_cancel_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

//End of study modal popup

//Start of Naming Character
#name_char_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px 24px;
  gap: 24px;

  position: absolute;
  width: 500px;
  height: max-content;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;

  background: #FFFFFF;
  border-radius: 30px;
}

#name_title {
  width: 558.27px;

  font-weight: 700;
  font-size: 26px;
  color: #48649F;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#name_input_box {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 10px;

  width: 500px;
  height: 64px;

  background: #FFFFFF;
  border: 2px solid #BBBDC2;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  font-size: 26px;
}

#name_input_box:hover {
  background: #BBBDC2;
  cursor: text;
}

#name_input_box:focus {
  background: #BBBDC2;
}

#name_cont_pos {
  position: absolute;
  width: 226px;
  height: 64px;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

//End of naming character

//Start of Choosing a Scenario
#scene_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  position: absolute;
  min-width: 904px;
  width: max-content;
  height: 116px;
  top: 20px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  color: #000000;
  font-size: 80px;
  font-weight: 700;
  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
}

#scene_desc {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  position: absolute;
  width: 1168px;
  height: 136px;
  top: 170px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  font-size: 22px;
  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
}

#scene_1_pos {
  position: absolute;
  left: 0px;
  top: 332px;
  left: 10%;
  z-index: 5;
}

#scene_2_pos {
  position: absolute;
  width: 480px;
  height: 632px;
  top: 332px;
  left: 37.5%;
  z-index: 5;
}

#scene_3_pos {
  position: absolute;
  width: 480px;
  height: 632px;
  top: 332px;
  left: 65%;
  z-index: 5;
}

#fungus_IMG {
  background: url(./assets/thumbnails/thumb_fungus_alternate.png);
  width: 448px;
  height: 240px;
  border-radius: 8px;
  background-position: center;
  background-size: 448px;
}

#seaweed_IMG {
  background: url(./assets/thumbnails/thumb_seaweed_alternate.png);
  width: 448px;
  height: 240px;
  border-radius: 8px;
  background-position: center;
  background-size: 448px;
}

#kawakawa_IMG {
  background: url(./assets/thumbnails/thumb_kawakawa_alternate.png);
  width: 448px;
  height: 240px;
  border-radius: 8px;
  background-position: center;
  background-size: 448px;
}

//End of scenarios

//Start of All Dialogues
#dialogue_scores {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px 16px 40px;
  gap: 26px;

  position: absolute;
  width: 225px;
  height: 70px;
  top: 40px;
  left: 3%;
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

#rela_ring {
  width: 64px;
  height: 64px;
  position: absolute;
  left: 10%;
  top: 23%;

  transform: scale(-1, -1);

  flex: none;
  order: 0;
  flex-grow: 0;
}

#rela_IMG {
  position: absolute;
  left: 18%;
  right: 20%;
  top: 20%;
  bottom: 24%;
  margin: auto;

  background: url(./assets/game_icons/relationship_icon.png);
  background-size: 38.4px;
  background-repeat: no-repeat;
  color: #B23256;
  transform: scale(-1, -1);
}

#fair_ring {
  width: 64px;
  height: 64px;
  position: absolute;
  left: 39%;
  top: 23%;

  transform: scale(-1, -1);

  flex: none;
  order: 1;
  flex-grow: 0;
}

#fair_IMG {
  position: absolute;
  left: 18%;
  right: 20%;
  top: 20%;
  bottom: 24%;
  margin: auto;

  background: url(./assets/game_icons/handshake_icon.png);
  background-size: 38.4px;
  background-repeat: no-repeat;
  color: #3247B2;

  transform: scale(-1, -1);
}

#equit_ring {
  width: 64px;
  height: 64px;
  position: absolute;
  left: 68%;
  top: 23%;

  transform: scale(-1, -1);

  flex: none;
  order: 1;
  flex-grow: 0;
}

#equit_IMG {
  position: absolute;
  left: 18%;
  right: 20%;
  top: 20%;
  bottom: 24%;
  margin: auto;

  background: url(./assets/game_icons/equity_icon.png);
  background-size: 38.4px;
  background-repeat: no-repeat;
  color: #32B285;
  transform: scale(-1, -1);
}

img {
  width: 32px;
  height: 32px;
  padding-left: 5px;

  vertical-align: middle;
  object-fit: contain;
}

a {
  color: #99b7f7;
  text-decoration: none;
}

a:visited {
  color: #99b7f7;
}

#context_icon {
  width: 64px;
  height: 64px;
  margin-left: 10px;

  background-image: url(./assets/game_icons/biocultural_icon.png);
  background-repeat: no-repeat;
  background-size: 100%;

  flex: none;
  order: 1;
  justify-self: center;
  flex-grow: 1;
}

#speaker_box {
  display: inline;
  flex-direction: row;
  justify-content: bottom;
  align-items: bottom;
  padding: 0px;

  position: absolute;
  width: 897px;
  height: max-content;
  //bottom: 850px;
  top: 150px;
  left: 28%;
  z-index: 5;

  background-color: #FFFFFF;
  filter: drop-shadow(0px 2px 0px rgba(0, 0, 0, 0.25));
  border-radius: 20px 20px 0px 20px;
  font-size: 22px;
  padding: 1%;
}

#invalidchoice_cont_pos {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}


#invalidchoice_speaker_box {
  display: inline;
  flex-direction: row;
  justify-content: bottom;
  align-items: bottom;
  padding: 0px;

  position: absolute;
  width: 897px;
  height: max-content;
  //bottom: 850px;
  top: 70%;
  left: 28%;
  z-index: 5;

  background-color: #FFFFFF;
  filter: drop-shadow(0px 2px 0px rgba(0, 0, 0, 0.25));
  border-radius: 20px 20px 0px 20px;
  font-size: 22px;
  padding: 1%;
}

#invalidchoice_jas_IMG {
  position: absolute;
  width: 960px;
  height: 1000px;
  bottom: 0px;
  right: 23%;

  background: url(./assets/characters/CharacterSprite_JasmineStrong_Alt.png);
  background-size: 55%;
  background-repeat: no-repeat;
}

#centred_speaker_IMG {
  position: absolute;
  width: 800px;
  height: 1000px;
  top: 0;
  right: 0;

  align-items: center;

  //background: #1be12549;
  z-index: 3;
}

#dialogue_title_box {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 80px;
  padding-left: 20px;
  padding-right: 20px;
  top: 40px;
  //top: 160px;
  //right: 2%;
  //left: 3%;
  left: 19.3%;
  z-index: 5;

  color: #000000;
  font-size: 40px;
  font-weight: 700;
  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
}

#choices_layout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 48px;

  position: absolute;
  width: 896px;
  height: 710px;
  top: 356px;
  left: 6.5%;
  z-index: 5;

  //background: rgba(216, 46, 46, 0.397);
  overflow-y: auto;
  overflow-x: show;
  scrollbar-width: thin;
}

#dialogue_cont_pos {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  position: absolute;
  //right: 81px;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

#bugreport_pos {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  position: absolute;
  top: 90%;
  right: 0%;
  z-index: 9;

  animation-name: button-fade;
  animation-duration: 2s;
  animation-delay: 6.5s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(.3, .5, .8, .6);
}

@keyframes button-fade {
  0% {
    opacity: 0;
    z-index: -5;
  }

  99% {
    opacity: 0;
    z-index: -5;
  }

  100% {
    opacity: 100;
    z-index: 9;
  }
}

#keyconsiderations_cont_pos {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  position: absolute;
  //right: 81px;
  top: 93%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

#speaker_IMG {
  position: absolute;
  width: 1010px;
  height: 890px;
  top: 227px;
  right: 0;

  align-items: center;

  //background: #1be12549;
  z-index: 3;
}

#tribal_IMG {
  position: absolute;
  width: 1007px;
  height: 850px;
  bottom: 0;
  right: 0;

  background: url(./assets/characters/CharacterSprite_TirbalLeaders_Alt.png);
  background-repeat: no-repeat;
}

#rawiri_IMG {
  position: absolute;
  width: 430px;
  height: 884px;
  bottom: 0;
  right: 13%;

  background: url(./assets/characters/CharacterSprite_Rawiri_Alt.png);
  background-repeat: no-repeat;
}

#gov_IMG {
  position: absolute;
  width: 430px;
  height: 884px;
  bottom: -10px;
  right: 13%;

  background: url(./assets/characters/CharacterSprite_MinisterLong_Alt.png);
  background-repeat: no-repeat;
}

#jas_IMG {
  position: absolute;
  width: 364px;
  height: 843px;
  bottom: -10px;
  right: 13%;

  background: url(./assets/characters/CharacterSprite_JasmineStrong_Alt.png);
  background-repeat: no-repeat;
}

#tribaLevel_Initiatives__IMG {
  position: absolute;
  width: 430px;
  height: 884px;
  bottom: -10px;
  right: 13%;

  background: url(./assets/characters/CharacterSprite_TirbalLeader2_Alt.png);
  background-repeat: no-repeat;
}

//End of dialogues

//Start of Budget Slider
#budget_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  gap: 8px;

  position: absolute;
  width: 1227px;
  height: 92px;
  top: 30px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 60px;
  font-weight: 700;
  color: #FFFFFF;
}

#budget_desc {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  position: absolute;
  width: 1149px;
  height: max-content;
  top: 172px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 22px;
}

.budget-slider-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 32px;
  gap: 42px;

  position: absolute;
  width: 676px;
  height: 350px;
  top: 462px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

.budget-slider-amount {
  display: flex;
  align-items: center;
  width: max-content;
  height: 76px;
  //transform: translate(25%);

  color: #FFFFFF;
  font-size: 60px;
  font-weight: 700;
  text-align: center;
  align-self: center;

  flex: none;
  order: 1;
  //align-self: stretch;
  flex-grow: 0;
}

#slider_max {
  width: 612px;
  height: 30px;

  color: #FFFFFF;
  font-size: 32px;
  font-weight: 700;
  text-align: center;

  flex: none;
  order: 3;
  //align-self: stretch;
  flex-grow: 0;
}

#slider_title {
  width: 400px;
  height: 38px;

  color: #FFFFFF;
  font-size: 30px;
  font-weight: 700;
  text-align: center;

  flex: none;
  order: 0;
  flex-grow: 0;
}

.budget-slider {
  width: 612px;
  height: 32px;

  flex: none;
  order: 2;
  flex-grow: 0;
}

.vue-slider-process {
  background-color: #36BA62 !important;
}

.vue-slider-rail {
  background-color: #BBBDC2 !important;
}

.vue-slider-dot-handle {
  width: 48px;
  height: 48px;
  margin-top: -100%;
  margin-left: -100%;

  background: #D9D9D9;
  border: 9px solid #FFFFFF;
}

.vue-slider-dot-tooltip-inner {
  visibility: hidden;
}

//End of Budget Slider

//Start of Not Enough Budget Modal
#no_budget_modal_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 8px;
  isolation: isolate;

  position: relative;
  width: 640px;
  height: 282px;
  margin: auto;
  top: 50%;
  transform: translate(0, -50%);

  background: #FFFFFF;
  border-radius: 20px 20px 0px 20px;
}

#no_budget_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  width: 422px;
  height: 66px;

  background: #48649F;
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#no_budget_desc {
  width: 560px;
  height: 72px;
  margin: auto;
  margin-top: -0%;

  color: #000000;
  font-size: 22px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#budget_okay_BTN {
  width: 550px;
  height: 34px;
  font-size: 22px;
  font-weight: 700;
  color: #EEEEEE;

  position: absolute;
  top: 72%;

  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
}

#budget_okay_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

//End of no-budget

//Start of Budget Allocation Grid
#allocation_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  gap: 8px;

  position: absolute;
  min-width: 687px;
  width: max-content;
  height: 92px;
  top: 30px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 60px;
  font-weight: 700;
  color: #000000;
}

#allocation_description {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  position: absolute;
  width: 1149px;
  height: 136px;
  top: 152px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 22px;
  color: #000000;
}

#alloc_background_lines_box {
  position: absolute;
  width: 1608px;
  height: 604px;
  top: 340px;
  left: 50%;
  transform: translate(-50%);
  z-index: 1;
}

#alloc_top_line {
  background: #48649F;

  position: absolute;
  width: 915px;
  height: 8px;
  top: 90px;
  left: 15%;
  border-radius: 10px;
}

#alloc_middle_line {
  background: #48649F;

  position: absolute;
  width: 1400px;
  height: 8px;
  top: 300px;
  left: 15%;
}

#alloc_bottom_line {
  background: #48649F;

  position: absolute;
  width: 915px;
  height: 8px;
  top: 510px;
  left: 15%;
  border-radius: 10px;
}

#alloc_vertical_line {
  background: #48649F;

  position: absolute;
  width: 8px;
  height: 429px;
  top: 89px;
  right: 22%;
  border-radius: 10px;
}

#allocation_grid_box {
  display: grid;
  grid-template-columns: 390px 228px 228px 228px 228px 298px;
  grid-template-rows: repeat(3, 180px);
  column-gap: 38px;
  row-gap: 32px;

  position: absolute;
  width: 1792px;
  height: 604px;
  top: 316px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;
}

.alloc_type_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;

  width: 340px;
  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

.column-1 {
  grid-column-start: 1;
}

.column-2 {
  grid-column-start: 2;
}

.column-3 {
  grid-column-start: 3;
}

.column-4 {
  grid-column-start: 4;
}

.column-5 {
  grid-column-start: 5;
}

.row-1 {
  grid-row-start: 1;
}

.row-2 {
  grid-row-start: 2;
}

.row-3 {
  grid-row-start: 3;
}

#type_title {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 292px;
  height: 32px;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#type_desc {
  width: 292px;
  height: 48px;

  color: #FFFFFF;
  font-size: 18px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.alloc_adds_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;
  isolation: isolate;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}


#adds_title {
  width: 192px;
  height: 50px;

  color: #000000;
  font-size: 18px;
  text-align: center;

  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 0;
}

#adds_cost {
  width: 192px;
  height: 34px;

  color: #000000;
  font-size: 26px;
  font-weight: 700;
  text-align: center;

  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
}

#adds_amount {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;

  position: relative;
  width: 64px;
  height: 64px;
  right: -106px;
  bottom: 200px;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 30px;
  font-weight: 700;

  flex: none;
  order: 3;
  flex-grow: 0;
  z-index: 3;
}

#adds_BTN_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 192px;
  height: 32px;

  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;
}

#adds_sub_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 32px;
  height: 32px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#adds_sub_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#adds_sub_BTN_nil {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 32px;
  height: 32px;

  background: #BFBFBF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#adds_sub_BTN_nil:active {
  background: #E1251B;
}

#adds_add_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 32px;
  height: 32px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#adds_add_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#adds_add_BTN_nil {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 32px;
  height: 32px;

  background: #BFBFBF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#adds_add_BTN_nil:active {
  background: #E1251B;
}

#alloc_remaining {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;

  grid-column: 6;
  grid-row-start: 1;
  grid-row-end: span 3;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

#remain_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 292px;
  height: 188px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#remain_title {
  width: 292px;
  height: 76px;

  color: #000000;
  font-size: 30px;
  font-weight: 700;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#remain_spent {
  width: 292px;
  height: 50px;

  color: #000000;
  font-size: 40px;
  font-weight: 700;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#remain_outOf {
  width: 140px;
  height: 30px;

  color: #000000;
  font-size: 22px;

  flex: none;
  order: 2;
  flex-grow: 0;
}

//End of budget grid

//Start of Best-Worst Survey
#speaker_placement {
  position: absolute;
  width: 1010px;
  height: 890px;
  top: 227px;
  right: 0;

  align-items: center;

  //background: #1be12549;
  z-index: 3;
}

#speaker_placement_alt {
  position: absolute;
  width: 1010px;
  height: 890px;
  top: 227px;
  right: -150px;

  align-items: center;

  //background: #1be12549;
  z-index: 3;
}

#survey_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 60px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 92px;
  top: 64px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 60px;
  color: #000000;
  font-weight: 700;
}

#survey_intro_desc {
  position: absolute;
  width: 1149px;
  height: max-content;
  top: 190px;
  left: 50%;
  transform: translate(-50%);
  padding: 25px 42px;
  gap: 8px;
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 18px;
  text-align: center;
}

#survey_def_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;

  position: absolute;
  width: 1233px;
  height: 608px;
  top: 320px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;
  //background-color: #B23256;
}

#survey_def_row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  //width: 1149px;
  height: max-content;
  filter: drop-shadow(0px 2px 0px rgba(0, 0, 0, 0.25));
  //background-color: #32b2853b;

  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

#survey_def_header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 12px; //16 24

  width: 250px;
  height: 40px;
  background: #48649F;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 800;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#survey_def_header2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 12px; //16 24

  width: 899px;
  height: 40px;
  background: #48649F;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 800;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
}

#survey_def_title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 12px; //16 24

  width: 250px;
  height: 80px;
  background: #FFFFFF;
  color: #000000;
  font-size: 18px;
  font-weight: 800;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#survey_def_desc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 12px;

  width: 899px;
  height: 80px;
  background: #FFFFFF;
  color: #000000;
  font-size: 18px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
}

#survey_def_box1 {
  flex: none;
  order: 0;
  flex-grow: 0;
  //background-color: #32B285;
}

#survey_choices_group {
  width: 830px;
  height: 353px;
  //background-color: #B23256;

  position: absolute;
  top: 433px;
  left: 50%;
  transform: translate(-50%);
  z-index: 4;
}

#least_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 8px;
  gap: 8px;

  position: absolute;
  width: 222px;
  height: max-content;
  bottom: 308px;
  left: -12%;
  z-index: 5;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

#most_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 8px;
  gap: 8px;

  position: absolute;
  width: 222px;
  height: max-content;
  bottom: 308px;
  right: -12%;
  z-index: 5;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

#question_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 92px;
  left: 50%;
  transform: translate(-50%);
  top: -100px;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-size: 60px;
  font-weight: 700;
  color: #FFFFFF;
}

#survey_container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;

  position: absolute;
  width: 830px;
  height: 226px;
  top: 55px;
  //left: 50%;
  //transform: translate(-50%);
  z-index: 4;

  //background-color: #B23256;
}

#survey_choice_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;

  width: 798px;
  height: 54px;

  background: #44474F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 18px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.animated {
  animation-name: survey-slide-out;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-direction: normal;
}

@keyframes survey-slide-out {
  0% {
    transform: translate(-50%, 0px);
  }

  25% {
    transform: translate(-50%, -1500px);
    opacity: 100;
  }

  26% {
    opacity: 0;
  }

  27% {
    transform: translate(-50%, 1000px);
    opacity: 100;
  }

  55% {
    transform: translate(-50%, -25px);
  }

  75% {
    transform: translate(-50%, 0px);
  }
}

#survey_choice_title {
  margin: 0 auto;
  width: max-content;
  height: 30px;
  font-weight: 400;
  font-size: 22px;

  color: #FFFFFF;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#survey_choice_title:hover {
  text-decoration: underline;
}

.tippy-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 8px;

  font-family: Inter;
  font-size: 22px;
  color: #000000;
  text-align: center;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

#radio_left {
  flex: none;
  order: 0;
  flex-grow: 0;
}

#radio_right {
  flex: none;
  order: 2;
  flex-grow: 0;
}

input[type="radio"] {
  appearance: none;
  //background-color: #44474F;
  margin: 0;
  width: 40px;
  height: 40px;
  border: 4.5px solid #FFFFFF;
  border-radius: 50%;

  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 20.87px;
  height: 20.87px;
  border-radius: 50%;
  transform: scale(0);
  transform: 120ms transform ease-in-out;
  box-shadow: inset 40px 40px #FFA400;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

//input[type="radio"]:checked {
//  border: 4.5px solid #FFA400;
//}

input[type="radio"]:hover {
  border: 4.5px solid #FFA400;
  cursor: pointer;
}

#survey_next_pos {
  position: absolute;
  width: 300px;
  height: 34px;
  top: 291px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;
}

#next_BTN_style {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 41px;
}

#next_BTN_style:hover {
  cursor: pointer;
  background: #7570A5;
}

#next_BTN_style_disabled {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  background: #BFBFBF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 41px;
}

#next_BTN_style_disabled:hover {
  cursor: not-allowed;
}

#next_BTN {
  //width: 51px;
  height: 30px;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #EEEEEE;

  flex: none;
  order: 1;
  flex-grow: 0;
}

//End of survey

//Start of demographic questionnaire
#quest_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 92px;
  top: 64px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-weight: 700;
  font-size: 60px;
}

#quest_container {
  position: absolute;
  width: 1055px;
  height: 882px; //1645
  top: 197.76px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  //background-color: #B23256;
  overflow-y: scroll;
  overflow-x: hidden;
}

#quest_content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px;
  gap: 32px;

  width: 980px; //1016
  height: 1645px;

  background: #FFFFFF;
}

#quest_content_desc {
  width: max-content;
  height: 34px;

  font-size: 26px;
  display: flex;
  align-items: center;

  color: #000000;

  flex: none;
  //order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#quest_role_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 968px;
  height: max-content; //300px

  flex: none;
  //order: 1;
  flex-grow: 0;
}

#quest_box_title {
  width: 750px;
  height: max-content;

  font-weight: 700;
  font-size: 26px;
  color: #000000;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#quest_box_title_mini {
  width: 330px;
  height: max-content;

  font-weight: 700;
  font-size: 26px;
  color: #000000;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#quest_role_column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 25px;

  width: 880px;
  height: 194px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#quest_role_outerrow {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 880px;
  height: 125px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#quest_role_innercolumn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 35px;

  width: 435px;
  height: 125px;

  flex: none;
  //order: 0;
  flex-grow: 0;
}

#quest_role_innerrow {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 25px;

  width: 435px;
  height: 40px;
  //background-color: #32B285;

  flex: none;
  //order: 0;
  flex-grow: 0;
}

#quest_answers {
  width: max-content;
  font-size: 22px;
  color: #000000;
}

#other_input_desc {
  width: max-content;
  font-size: 22px;
  color: #000000;
}

#demo_radio {
  border-color: #000000;
}

#demo_radio:hover {
  border-color: #FFA400;
}

#other_input_box {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 10px;

  width: 85%; //500
  height: 44px;

  background: #FFFFFF;
  border: 2px solid #BBBDC2;
  font-size: 22px;
}

#other_input_box:hover {
  background: #BBBDC2;
  cursor: text;
}

#other_input_box:focus {
  background: #BBBDC2;
}

#quest_box_input {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  //width: 728px;
  height: 45px;

  background: #FFFFFF;
  border: 2px solid #BBBDC2;
  font-size: 22px;

  flex: none;
  //order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#quest_box_input:hover {
  background: #BBBDC2;
  cursor: text;
}

#quest_box_input:focus {
  background: #BBBDC2;
}

#quest_role_singlerow {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 25px;

  //width: 701px;
  height: 45px;
  //background-color: #3247B2;

  flex: none;
  order: 1;
  flex-grow: 0;
  align-self: stretch;
}

#quest_eth_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 968px;
  height: max-content;

  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

#quest_eth_outerrow {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;

  width: 882px;
  height: 232px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#quest_eth_column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;

  width: 429px;
  height: 168px;

  flex: none;
  //order: 1;
  flex-grow: 0;
}

#quest_eth_singlerow {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 25px;

  //width: 435px;
  height: 45px;

  flex: none;
  //order: 2;
  flex-grow: 0;
  align-self: stretch;
}

#quest_years_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 968px;
  height: max-content;

  flex: none;
  flex-grow: 0;
  align-self: stretch;
}

#quest_count_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 968px;
  height: max-content;

  flex: none;
  flex-grow: 0;
  align-self: stretch;
}

#quest_job_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 968px;
  height: max-content; //117/

  flex: none;
  flex-grow: 0;
  align-self: stretch;
}

#quest_exp_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 968px;
  height: max-content;

  flex: none;
  flex-grow: 0;
  align-self: stretch;
}

#quest_cont_pos {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 8px;

  width: 930px;
  height: 112px;
  //background-color: #B23256;

  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

//End of questionnaire

//Start of Stage Complete Screens
#stage_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 116px;
  top: 64px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 80px;
  font-weight: 700;
  color: #000000;
}

#stage_text_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px 24px;
  gap: 24px;
  //isolation: isolate;

  position: absolute;
  width: 724px;
  height: 440px;
  top: 350px;
  left: 50%;
  transform: translate(-50%);
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
}

#stage_text_box2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px 24px;
  gap: 24px;
  //isolation: isolate;

  position: absolute;
  width: 724px;
  height: 440px;
  top: 390px;
  right: 200px;
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
}

#stage_result_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 8px;

  position: absolute;
  min-width: 120px;
  width: max-content;
  height: 35px;
  left: -16px;
  top: -50px;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #FFFFFF;

  flex: none;
  order: 2;
  flex-grow: 0;
}

#stage_results_desc {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 508px;
  height: max-content;
  font-size: 30px;
  text-align: center;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#stage_rela_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 20px;

  width: 628px;
  height: 100px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#stage_rela_desc {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 0px;
  gap: 8px;

  width: 508px;
  height: max-content;
  font-size: 22px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#stage_rela_ring {
  width: 110px;
  height: 110px;

  transform: scale(-1, -1);

  flex: none;
  order: 0;
  flex-grow: 0;
}

#stage_rela_IMG {
  position: relative;
  margin: auto;
  top: 0%;
  left: 1%;
  width: 60px;
  height: 60px;

  transform: scale(-1, -1);

  background: url(./assets/game_icons/relationship_icon.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

#stage_fair_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 20px;

  width: 628px;
  height: 100px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#stage_fair_desc {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 0px;
  gap: 8px;

  width: 508px;
  height: max-content;
  font-size: 22px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#stage_fair_ring {
  width: 110px;
  height: 110px;

  transform: scale(-1, -1);

  flex: none;
  order: 0;
  flex-grow: 0;
}

#stage_fair_IMG {
  position: relative;
  margin: auto;
  top: 0%;
  left: 1%;
  width: 60px;
  height: 60px;

  transform: scale(-1, -1);

  background: url(./assets/game_icons/handshake_icon.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

#stage_equit_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 20px;

  width: 628px;
  height: 100px;

  flex: none;
  order: 2;
  flex-grow: 0;
}

#stage_equit_desc {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 0px;
  gap: 8px;

  width: 508px;
  height: max-content;
  font-size: 22px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#stage_equit_ring {
  width: 110px;
  height: 110px;

  transform: scale(-1, -1);

  flex: none;
  order: 0;
  flex-grow: 0;
}

#stage_equit_IMG {
  position: relative;
  margin: auto;
  top: 0%;
  left: 1%;
  width: 60px;
  height: 60px;

  transform: scale(-1, -1);

  background: url(./assets/game_icons/equity_icon.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

#stage_text_layout {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px 24px;
  gap: 24px;

  position: absolute;
  width: 632px;
  min-height: 100px;
  height: max-content;
  left: 23%;
  top: 430px;
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
}

#stage_text_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 8px;

  position: absolute;
  width: max-content;
  height: 36px;
  left: -16px;
  top: -50px;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 26px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;
}

#stage_text_desc {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 600px;
  height: 60;

  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;

  background: #FFFFFF;
  font-size: 22px;
  text-align: center;
}

#stage_cont_pos {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

#gamecomplete_survey_pos {
  position: absolute;
  top: 82%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

#reward_IMG {
  position: absolute;
  width: 500px;
  height: 572px;
  top: 255px;
  right: 18%;

  align-items: center;

  //background: #1be12549;
  z-index: 4;
}

#stage_bronze {
  width: 100%;
  height: 100%;
  background: url(./assets/tikis/tiki_Bronze.png);
  background-position: center;
  background-size: 59%;
  background-repeat: no-repeat;
}

#stage_silver {
  width: 100%;
  height: 100%;
  background: url(./assets/tikis/tiki_Silver.png);
  background-position: center;
  background-size: 92%;
  background-repeat: no-repeat;
}

#stage_gold {
  width: 100%;
  height: 100%;
  background: url(./assets/tikis/tiki_Gold.png);
  background-position: center;
  background-size: 97%;
  background-repeat: no-repeat;
}

#survey_result_desc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 16px 24px;
  gap: 24px;

  position: absolute;
  width: 669px;
  height: max-content;
  top: 220px;
  left: 50%;
  transform: translate(-50%);
  z-index: 8;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  font-size: 22px;
}

#survey_rank_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 16px 5px 16px;
  gap: 24px;
  isolation: isolate;

  position: absolute;
  width: 665px;
  height: max-content; //546px
  top: 370px;
  right: 1025px;
  z-index: 5;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
}

#survey_rank_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 16px 24px 16px 40px;
  gap: 26px;

  width: 633px;
  height: 482px;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#survey_rank_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: max-content;
  height: 42px;
  //background-color: #B23256;

  flex: none;
  //order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#survey_rank_number {
  width: 42px;
  height: 42px;

  font-weight: 700;
  font-size: 32px;
  display: flex;
  align-items: center;

  color: #000000;
  //background-color: #3247B2;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#survey_rank_desc {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 0px;
  gap: 8px;

  width: 550px;
  height: max-content; //34px
  //background-color: #32B285;
  color: #000000;
  font-size: 26px;
  text-wrap: balance;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#rank_most_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 4px;
  gap: 8px;

  position: absolute;
  min-width: 432px;
  width: max-content;
  height: 32px;
  left: -16px;
  top: -30px;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-weight: 700;
  font-size: 22px;
  text-align: center;
  color: #FFFFFF;

  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
}

#rank_least_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 4px;
  gap: 8px;

  position: absolute;
  width: 432px;
  height: 32px;
  left: -16px;
  top: 735px;

  background: #48649F;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-weight: 700;
  font-size: 22px;
  text-align: center;
  color: #FFFFFF;

  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;
}

//End of stage complete

//Start of Game Completion
#comp_overall {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  gap: 12px;

  position: absolute;
  width: 538px;
  height: 1017px;
  left: 120px;
  top: 30px;

  filter: drop-shadow(0px 2px 0px rgba(0, 0, 0, 0.25));
  background-color: #ffffff;
  z-index: 5;
}

#overall_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  position: absolute;
  width: 278px;
  height: 44px;
  top: -24px;
  left: 50%;
  transform: translate(-50%);

  background: #FFA400;
  font-size: 30px;
  font-weight: 700;
  color: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);

  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
}

#overall_desc {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 40px 24px 16px;

  font-size: 18px;
}

#overall_tiki_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  width: 490px;
  height: 36px;
  background: #48649F;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;
}

#overall_tiki_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 450px;
  height: 250px; //356px
  //background-color: #32B285;
}

#overall_bronze_IMG {
  width: 242px;
  height: 180px; //281px
  margin: 0px 0px 10px 0px;

  background-image: url(./assets/tikis/tiki_Bronze.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

#overall_silver_IMG {
  width: 242px;
  height: 180px;
  margin: 0px 0px 10px 0px;

  background-image: url(./assets/tikis/tiki_Silver.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

#overall_gold_IMG {
  width: 242px;
  height: 180px;
  margin: 0px 0px 10px 0px;

  background-image: url(./assets/tikis/tiki_Gold.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

#overall_tiki_desc {
  font-size: 22px;
  font-weight: 700;
  color: #000000;
}

#overall_score_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  width: 490px;
  height: 46px;

  background: #48649F;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
}

#overall_rings_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 40px;

  width: 276px;
  height: 118px;
}

#overall_rings_frame {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
}

#overall_ring {
  width: 80px;
  height: 80px;
  transform: scale(-1, -1);

  flex: none;
  order: 0;
  flex-grow: 0;
}

#overall_rings_title {
  font-weight: 700;
  font-size: 22px;
  color: #000000;
}

#overall_rela_IMG {
  position: relative;
  margin: auto;
  width: 40px;
  height: 40px;
  top: 0%;
  left: 1%;
  transform: scale(-1, -1);

  background-image: url(./assets/game_icons/relationship_icon.png);
  background-size: contain;
  background-repeat: no-repeat;
}

#overall_fair_IMG {
  position: relative;
  margin: auto;
  width: 40px;
  height: 40px;
  top: 0%;
  left: 1%;
  transform: scale(-1, -1);

  background-image: url(./assets/game_icons/handshake_icon.png);
  background-size: contain;
  background-repeat: no-repeat;
}

#overall_equit_IMG {
  position: relative;
  margin: auto;
  width: 40px;
  height: 40px;
  top: 0%;
  left: 1%;
  transform: scale(-1, -1);

  background-image: url(./assets/game_icons/equity_icon.png);
  background-size: contain;
  background-repeat: no-repeat;
}

#completion_BTN_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  //padding: 16px 24px;
  gap: 8px;
}

#completion_return_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 180px;
  height: 34px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 18px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#completion_return_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#completion_replay_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 180px;
  height: 34px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 18px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#completion_replay_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#completion_resource_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 440px;
  height: 34px;
  z-index: 5;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 18px;
  font-weight: 700;
  color: #EEEEEE;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#completion_resource_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#completion_questions_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  position: relative;
  width: 440px;
  height: 34px;
  z-index: 5;

  background: #FFA400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 18px;
  font-weight: 700;
  color: #111111;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#completion_questions_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#link_span {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 1;
  border-radius: 100px;
  //background-color: #ff00007a;
}

#comp_levels_scroll {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 24px;

  position: absolute;
  width: 1122px;
  height: 1037px;
  top: 30px;
  right: 100px;

  //background-color: #b232563b;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  z-index: 5;
}

#comp_level_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px 32px;
  gap: 24px;

  width: 1054px;
  height: max-content;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#comp_level_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //padding: 8px 16px;
  gap: 8px;

  width: 1054px;
  height: 46px;
  background: #48649F;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#comp_ring {
  width: 55px;
  height: 55px;
  transform: scale(-1, -1);

  flex: none;
  order: 0;
  flex-grow: 0;
}

#comp_scores_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 450px;
  height: 58px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#comp_desc_rows {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  width: 420px;
  height: 58px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#comp_scores_title {
  font-size: 22px;
  color: #000000;
}

#comp_scores_desc {
  font-size: 16px;
  color: #000000;
}

#comp_rela_IMG {
  position: relative;
  margin: auto;
  width: 30px;
  height: 30px;
  top: 0%;
  left: 1%;
  transform: scale(-1, -1);

  background-image: url(./assets/game_icons/relationship_icon.png);
  background-size: contain;
  background-repeat: no-repeat;
}

#comp_fair_IMG {
  position: relative;
  margin: auto;
  width: 30px;
  height: 30px;
  top: 0%;
  left: 1%;
  transform: scale(-1, -1);

  background-image: url(./assets/game_icons/handshake_icon.png);
  background-size: contain;
  background-repeat: no-repeat;
}

#comp_equit_IMG {
  position: relative;
  margin: auto;
  width: 30px;
  height: 30px;
  top: 0%;
  left: 1%;
  transform: scale(-1, -1);

  background-image: url(./assets/game_icons/equity_icon.png);
  background-size: contain;
  background-repeat: no-repeat;
}

#comp_leveLevel_Access_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px 32px;
  gap: 24px;

  width: 1054px;
  height: max-content;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#comp_Level_Access__title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //padding: 8px 16px;
  gap: 8px;

  width: 1054px;
  height: 46px;
  background: #48649F;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#comp_Level_Access__scores {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  width: 1054px;
  height: 206px;
  //background-color: #32B285;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#comp_Level_Initiatives__column {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //padding: 0px 32px;
  gap: 24px;

  width: 1054px;
  height: 444px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#comp_Level_Initiatives__row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 483px;
  height: 444px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
}

#comp_Level_Initiatives__title {
  font-size: 22px;
  font-weight: 700;
  color: #000000;
}

#comp_Level_Initiatives__desc {
  font-size: 18px;
  color: #000000;
}

#comp_Level_Initiatives__desc2 {
  font-size: 16px;
  color: #000000;
  width: 335px;
}

#comp_Level_Initiatives__desc3 {
  font-size: 18px;
  color: #000000;
  width: 100px;
  text-align: right;
}

#comp_ini_row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 500px;
  height: 24px;
}

#comp_ini_gapless {
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: 2px;
}

#comp_Level_KeyConsiderations__column {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //padding: 0px 32px;
  gap: 24px;

  width: 1054px;
  height: 310px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#comp_Level_KeyConsiderations__row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 483px;
  height: 310px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
}

#comp_Level_KeyConsiderations__rank-col {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
}

#comp_Level_KeyConsiderations__desc {
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  width: 20px;
}

#comp_Level_CulturalLicenseEval__column {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //padding: 0px 32px;
  gap: 24px;

  width: 1054px;
  height: 200px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#comp_Level_CulturalLicenseEval__row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 483px;
  height: 200px;
  font-size: 18px;
  color: #000000;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
}

#comp_Level_CulturalLicenseEval__row2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 483px;
  height: 200px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
}

#comp_tiki_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 175px;
  height: 200px;
}

#comp_bronze_IMG {
  width: 175px;
  height: 200px;

  background-image: url(./assets/tikis/tiki_Bronze.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

#comp_silver_IMG {
  width: 175px;
  height: 200px;

  background-image: url(./assets/tikis/tiki_Silver.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

#comp_gold_IMG {
  width: 175px;
  height: 200px;

  background-image: url(./assets/tikis/tiki_Gold.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

#comp_Level_StrategicApproach__column {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //padding: 0px 32px;
  gap: 24px;

  width: 1054px;
  height: 213px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#comp_Level_StrategicApproach__row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 483px;
  height: 213px;
  font-size: 18px;
  color: #000000;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
}

//End of game complete

//Start of Failure to Gain Consent
#fail_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 40px;

  position: absolute;
  width: 600px;
  height: 505.44px;
  top: 25%;
  left: 35%;

  //background: #3247B2;
  z-index: 6;
}

#fail_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  width: 297px;
  height: 116px;

  background: #FA2C2C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  transform: rotate(-5deg);
  font-size: 80px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 0;
  flex-grow: 0;

  animation-name: overTitleZoom;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: ease-in;
}

#fail_desc_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding: 8px 8px 16px;
  gap: 40px;

  width: 600px;
  height: 200px;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#fail_desc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px;
  gap: 24px;

  width: 584px;
  height: 196px;
  margin-top: 5%;
  font-size: 22px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#fail_BTN_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 32px;

  width: 600px;
  height: 34px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  animation-name: overFadeIn;
  animation-duration: 0.5s;
  animation-delay: 1.5s;
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
}

#fail_return_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 262px;
  height: 34px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#fail_return_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#fail_restart_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 176px;
  height: 34px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#fail_restart_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#fail_forward_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 273px;
  height: 64px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 41px;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 2;
  flex-grow: 0;
}

#fail_forward_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

//End of fail

//Start of Game Over
#over_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 40px;

  position: absolute;
  width: 600px;
  height: 403.05px;
  top: 30%;
  left: 35%;

  //background: #BE5870;
}

#over_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  width: 499px;
  height: 116px;

  background: #FA2C2C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  transform: rotate(-5deg);
  font-size: 80px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 0;
  flex-grow: 0;

  animation-name: overTitleZoom;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: ease-in;
}

@keyframes overTitleZoom {
  0% {
    opacity: 0;
    transform: scale(2);
  }

  100% {
    opacity: 100;
  }
}

#animated_screen {
  transform: translate3d(0, 0, 0);
  animation-name: shake;
  animation-duration: 1s;
  animation-delay: 0.8s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);
}

@keyframes shake {

  10%,
  90% {
    transform: translate3d(-1px, 2px, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 5px, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 10px, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

#over_desc_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 8px 16px;
  gap: 40px;

  width: 600px;
  height: 100px;

  background: #FFFFFF;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#over_desc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px;
  gap: 24px;

  width: 584px;
  height: 76px;
  margin-top: 3%;
  font-size: 22px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

#over_BTN_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 32px;

  width: 600px;
  height: 34px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  animation-name: overFadeIn;
  animation-duration: 0.5s;
  animation-delay: 1.5s;
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
}

@keyframes overFadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 100;
  }
}

#over_return_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 262px;
  height: 34px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 0;
  flex-grow: 0;
}

#over_return_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

#over_restart_BTN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;

  width: 176px;
  height: 34px;

  background: #3B726C;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 41px;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;

  flex: none;
  order: 1;
  flex-grow: 0;
}

#over_restart_BTN:hover {
  background: #7570A5;
  cursor: pointer;
}

//End of game over

.talk-pad {
  position: absolute;
  background-color: darkslategrey;
  font-size: large;
  padding: 2em;
  color: white;
  height: 25%;
  left: 2em;
  right: 2em;
  bottom: 2em;
  pointer-events: none;
}

.option-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.option-overlay-bg {
  opacity: 0.5;
  background-color: black;
}

.option {
  width: 40%;
  height: 5em;
  background-color: lightgreen;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  margin: 1em;
}

.tag-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  left: 2em;
  right: 2em;
  top: 2em;
  bottom: 2em;
}

.variable-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  left: 2em;
  right: 2em;
  top: 2em;
  bottom: 2em;
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: end;
  padding: 2em;
  pointer-events: none;
}

.button {
  background-color: white;
  border-radius: 8px;
  cursor: pointer;
  padding: 0.5em;
  pointer-events: auto;
  margin: 0.5em;
}

.path-text-container {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: start;
  left: 2em;
  right: 2em;
  top: 1em;
  bottom: 1em;
  pointer-events: none;
}

.priorityRankingContainer {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
}
</style>
